function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:#6F2CC6;}\n\t.st5{fill:url(#SVGID_4_);}\n\t.st6{fill:url(#SVGID_5_);}\n\t.st7{fill:url(#SVGID_6_);}\n\t.st8{fill:url(#SVGID_7_);}\n\t.st9{fill:url(#SVGID_8_);}\n\t.st10{fill:url(#SVGID_9_);}\n\t.st11{fill:url(#SVGID_10_);}\n\t.st12{fill:url(#SVGID_11_);}\n\t.st13{fill:url(#SVGID_12_);}\n\t.st14{fill:url(#SVGID_13_);}\n\t.st15{fill:url(#SVGID_14_);}\n\t.st16{fill:url(#SVGID_15_);}\n\t.st17{fill:none;stroke:#000000;stroke-width:8.72;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 358.9,
  cy: 358.9,
  r: 326.6
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M682.2,271.7V416c-29.5,9.6-70.9,26-81.9,26.3c-1,0-80.8,11.7-81.4,10.9l15.5-56.1c-1.4-1.8-3.9-2.4-6-1.6 c-6.9,2.4-21.1,3.6-27,5.1c-7.2,1.8-8.6,7.2-11.5,14.7c-2.8,7.5-6.8,17.7-7.9,20.9c-1.1,3.2-5.8,7.9-13,14.1 c-7.2,6.1-12.3,6.1-24.2,3.3c-8.4-2-13.5-10.7-15.8-15.6c-1-2-3.2-3.2-5.4-2.9c-19.7,2.3-27.3-3.8-31.7-6.3 c-3.7-2.1-14-11.7-18.3-15.7c-1.2-1.1-1.8-2.7-1.6-4.3c1.4-14.1,8-82.3,9.8-101.5c1.6-16.6,3.9-19.7,4.9-20.1c0.5-0.2,1-0.6,1.4-1 l70.3-69c4.3-4,9.3-7.2,14.7-9.5c8.9-3.6,19.7-4.8,27.4-5.4c6.2-0.5,16.7-0.4,20.6-0.3c1,0,2-0.2,2.8-0.8c3.8-2.3,14.6-9,16.1-10.5 c1.8-1.9,12-7.6,18-3.5c4.3,2.9,4.6,13.6,4.4,19.6v0.2c0,2.4,1.6,4.5,3.9,5.1l0.4,0.1c23.4,8.2,49.5,24.3,54.5,28.4 C625.5,244,652,255.9,682.2,271.7z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M347.4,365.9c-0.6,5.9,1.1,16.6,0.6,23.1c-0.6,6.5-7.1,19.5-9.4,22.2c-4.6,5.7-10.8,9.9-17.9,11.9 c-10.2,3-94.2,25.9-94.2,25.9s-13.7-3.6-51-11s-51-13.8-67.1-18.4c-23.8-6.7-39.7,4.8-47.5,8.8c-4,2.1-14.9,6.3-22.6,9.3 c-10.6-43.3-12.3-88.3-5.2-132.3c8.6-5.5,20.6-13.3,37.3-24.6c66.1-44.1,86.6-63.9,86.6-63.9s21.2-20.6,24.9-22 c3.7-1.3,18.2-6,26.8-1.2c7.3,4,5.6,3.9,4.8,3.8c4.4,1.4,8.5,3.6,12,6.6c5.4,4.8,26.6,21.3,41.1,26.3c14.5,5,53.3,33,59.8,40.1 s18,7,21,19.2s2.3,15.6-7.7,30.3c-1.4,2.1-3.2,4.6-5.2,7.2c-12.2,16.2-32.8,40.6-32.8,40.6s-11.3,21.5-54.5,7.8 s-53.4-23.3-40.9-32.8c12.4-9.4,52.6-11.3,52.6-11.3s1.2-10.5,6.2-11.5c5-0.9-11.5,0.3-23.2-13.6c0,0-4.3-5.6-5.1-10 c0.2,2.7,0.3,13.8-11.7,16.5c-15.4,3.5-23.3-0.8-23.3-0.8s-14.5,42,2.8,51.6c12.1,6.6,25.1,11.3,38.7,14c6.7,1.6,42.3,11.5,56.1-4 c9.5-10.6,25.5-33.1,35.5-46.4c4.5-6,7.7-10.1,8.5-10.4c2.5-0.7,10.5-4.3,12.9,3.7s-0.8,28.5-1.7,30.4 C353.5,353.1,348,360,347.4,365.9z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M257.3,165c0.3,1.2,0.5,1.9,0.9,3.1c-1.4,0.8-2.7,1.8-3.8,3c-1,1.3-1.1,2.1-0.5,2.6c0.6,0.4,1.1,0.2,2.3-0.3 c1.6-0.7,2.3-1,3.9-1.6c2.5-1,4.2-1.1,5.8,0.2c2.3,2,1.6,4.9-0.9,8.3c-1.5,1.9-3.3,3.5-5.5,4.7c-0.5-1.2-0.7-1.8-1.2-2.9 c1.7-0.9,3.2-2.1,4.5-3.6c1.2-1.5,1.3-2.7,0.6-3.3c-0.7-0.6-1.6-0.3-3,0.3s-2.1,0.9-3.6,1.6c-2.3,1.1-4.1,1.3-5.5,0.3 c-2-1.5-1.9-4.4,0.8-7.8C253.6,167.7,255.4,166.2,257.3,165z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M285.1,140.1l8.7,13.5c-1.2,0.8-1.7,1.1-2.9,1.9l-4-5.8c-3.1,2.1-4.7,3.3-7.7,5.7l4.4,5.5c-1.1,0.9-1.6,1.3-2.7,2.2 l-10.4-12.3c1.2-1,1.8-1.5,3.1-2.5l3.9,4.9c3.1-2.5,4.6-3.6,7.8-5.8c-1.4-2.1-2.1-3.1-3.5-5.1C283.1,141.4,283.8,140.9,285.1,140.1z "
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M317.8,137.9c-2.9,1-4.4,1.6-7.3,2.8c0,1.6,0,2.4,0,4c-1.4,0.6-2.1,0.9-3.4,1.6c-0.1-6,0.2-11.9,0.8-17.9 c1.4-0.6,2.1-0.8,3.6-1.4c4.5,4,8.7,8.2,12.6,12.7c-1.4,0.4-2.1,0.7-3.6,1.1C319.4,139.6,318.9,139.1,317.8,137.9z M315.8,135.8 c-1.9-2-2.9-3-4.9-4.9c-0.2,2.8-0.3,4.2-0.4,6.9C312.6,136.9,313.7,136.5,315.8,135.8L315.8,135.8z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M353.8,134.8l-3.1,0.2c-3.2-3.6-6.7-6.9-10.4-10l0,0c0.6,4.4,0.9,6.6,1.5,10.9c-1.3,0.2-2,0.3-3.3,0.5 c-1.1-6.3-1.6-9.5-2.7-15.8c1.4-0.2,2.1-0.3,3.5-0.5c3.8,3.1,7.4,6.4,10.8,10l0,0l-0.7-11c1.5-0.1,2.3-0.1,3.8-0.2 C353.4,125.2,353.6,128.4,353.8,134.8z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M389.8,130.4c-1.1,4.4-4.9,7.4-11,6.4c-5.5-0.9-9.3-4.5-8.8-9.6s5.1-8.1,11.8-6.9c2.8,0.4,5.4,1.7,7.5,3.7 c-1.2,0.8-1.8,1.1-3,1.9c-1.4-1.4-3.2-2.3-5.1-2.6c-4.1-0.7-6.9,1.3-7.3,4.4c-0.4,3,1.8,5.6,5.6,6.2c3.6,0.6,5.6-0.9,6.2-2.6 c-2.2-0.5-3.3-0.7-5.4-1l0.5-2.7c3.8,0.6,5.6,1,9.3,1.9C390,129.8,390,130.1,389.8,130.4z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M424.4,135.5l-7.8,14.1c-1.2-0.7-1.8-1-3-1.6c1.3-2.5,1.9-3.8,3.3-6.3c-3.3-1.7-5-2.5-8.4-4c-1.1,2.6-1.6,3.9-2.8,6.6 c-1.3-0.5-1.9-0.8-3.1-1.3l5.9-15c1.4,0.6,2.1,0.9,3.6,1.5c-1,2.3-1.5,3.4-2.4,5.7c3.5,1.5,5.2,2.3,8.6,4.1l2.8-5.5 C422.4,134.4,423.1,134.8,424.4,135.5z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M442.4,163.8c-2.4-2.2-3.7-3.3-6.2-5.4c-1.4,0.7-2.1,1.1-3.6,1.8c-1.2-0.9-1.8-1.4-3.1-2.3c5.3-2.9,10.7-5.4,16.4-7.6 c1.2,1,1.8,1.6,3,2.6c-1.3,5.9-3.1,11.7-5.2,17.4c-1.1-1.1-1.6-1.6-2.8-2.8C441.6,166,441.8,165.2,442.4,163.8z M443.3,161 c0.8-2.7,1.2-4,1.9-6.7c-2.6,1.1-3.9,1.6-6.4,2.9C440.6,158.5,441.5,159.3,443.3,161L443.3,161z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M456.6,185.6c-0.9-1.2-1.3-1.8-2.2-3l12.8-9.6c1,1.4,1.5,2,2.5,3.4L456.6,185.6z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M402.4,190.3c1.5-1.4,2.8-3,3.9-4.8c0.5-0.9,0.9-1.9,0.9-2.9c0-0.3,0-0.6,0-0.9c-0.2-1.1-1.2-1.6-2.6-1.1 c-0.8,0.3-1.3,1-2.1,1.2c-2.1,0.4-4,1.1-5.9,2.1c-2.5,1.3-5.1,2.4-7.6,3.7c-0.3,0.1-0.8,0.4-1,0.3c-0.2-0.1-0.2-0.7-0.1-1 s0-0.6-0.1-0.9c-0.3-0.8-0.5-1.7-0.6-2.6c0.1-2.2-0.7-4.3-2.3-5.9c-1.6-1.5-2.8-3.5-4.5-4.9s-3.2-2.9-4.6-4.6 c-1.3-1.6-2.6-3.1-3.8-4.7c-0.5-0.7-1-1.4-1.5-2.1c-0.4-0.3-0.8-0.7-1.2-1.1c-0.8-0.8-1.3-1.8-1.7-2.8c-0.2-0.4-0.3-0.8-0.5-1.2 c-0.3-0.8-0.4-1.4-1.4-1.6c-0.7-0.1-1.4-0.1-2.1,0c-0.6,0.1-1.1,0.3-1.6,0.6c-0.1,0-0.1,0.2-0.2,0.4c-0.5,1.5-0.9,3-1.2,4.5 c-0.1,0.8-0.3,1.6-0.4,2.3c-0.3,1.1-0.6,2.1-1.1,3.1c-0.1,0.3-0.1,0.6-0.3,0.8c-0.4,0.8-0.8,1.6-1.1,2.4c-0.7,2-1.6,3.9-2.8,5.7 c-1.4,1.6-1.8,1.7-3.4,0l0,0c-1.1-1.2-2.5-2.1-4-2.8c-0.9-0.3-2.1-0.6-2.6-1.7c-0.3-0.6-1.9-0.5-2,0c-0.4,0.8-0.6,1.7-0.6,2.6 c0.1,0.5,0.1,1,0,1.5c0.1,0.5,0.1,1,0.2,1.6c0.1,0.1,0.2,0.3,0.2,0.5c-0.1,1.2,0,2.3,0,3.5c-0.1,0.9-0.3,1.8-0.6,2.6l0,0 c-0.2,0.4-0.2,0.9-0.2,1.4c0,0.8-0.1,1.6-0.4,2.4c0,0.3-0.3,0.6-0.7,0.6c-0.4,0-0.3-0.4-0.4-0.7c-0.2-0.9-0.3-1.8-0.4-2.7 c-0.1-0.2-0.1-0.5,0-0.7c-0.1-0.1-0.1-0.2-0.2-0.4c0-0.2,0-0.5,0-0.7v-0.2c0-0.3,0-0.7,0-1s0-0.9,0-1.3c-0.2-0.2-0.4-0.3-0.6-0.5 c-0.5-0.4-0.9,0.1-1.3,0.4c-0.4,0.3-1.1,0.6-1.5,0c-0.8-1.4-2.2-1.7-3.5-2.4c-2.6-1-5.1-2.2-7.6-3.5c-1.2-0.6-2.6-0.8-3.8-0.3 c-1,0.2-1.8,2-1.6,3.5c0.3,1.7,0.4,3.5,0.4,5.2c0,1.4-0.1,2.7-0.3,4.1c0.3,2.1,0,4.2,0.2,6.3c0,0.4,0.1,0.9,0.1,1.3 c0.5,2.6,1.3,5.2,2.4,7.6c0.5,0.7,1.1,1.4,1.6,2.1c0.9,1.3,1.8,2.8,2.8,4c0.4,0.5,0.6,1,1.3,1.2c0.2,0,0.6,0.1,0.6,0.5 c0,0.3-0.4,0.3-0.7,0.4c-1.7,0.3-3.2,0.8-4.7,1.6c-2.4,1.5-4.6,3.4-6.6,5.5c-1.8,1.5-3.4,3.1-4.8,4.9c-0.7,0.8-1.4,1.6-2.1,2.4 c-1.2,1.4-1.8,3.3-3,4.6c-0.5,0.5-0.8,1.1-0.9,1.8c0,0.4,0.1,0.8,0.1,1.2c0.2,1.1,0.6,2.1,0.9,3.1c0.2,0.5,0.6,0.9,1.1,1.1 c2,1.1,4.1,1.9,6.3,2.5c1.3,0.2,2.5,0.7,3.6,1.3c2.5,1.5,5.2,2.5,8,3c0.9,0.1,1.8,0.3,2.7,0.6c1.4,0.7,2.9,1.1,4.5,1.3 c2.3,0.2,4.7-0.1,7,0.2c1.3,0.1,2.5,1,2.8,2.3c0.4,1.7,0.5,3.4,0.3,5.2c-0.3,1.1,0.1,2.2,1,2.9c1,0.9,2.5,1,3.7,0.3 c1.9-1.3,4.1-2.2,6.3-2.7c1.8-0.2,3.7-0.6,5.5-0.8c0.9,0,1.6-0.4,2.5-0.4c1.9-0.1,3.7-0.9,5-2.3c0.5-0.5,1.2-0.7,1.9-0.4l0.5,0.2 c2.1,0.1,4.2,0.5,6.3,0.6c2.3,0,4.6-0.1,6.9-0.3c3.3-0.2,6.6-0.7,9.8-1.6c1.6-0.7,3.1-1.5,4.8-2c3-0.9,6.2-1.4,9.3-1.6 c1.6-0.4,3.2-0.6,4.8-0.6c3.7,0.5,6.4-4.5,5.3-7.5c-1.2-2.6-2.6-5.1-4.2-7.4c-2.2-3.4-5.6-5.9-9.6-7c-1.6-0.5-3.3-0.7-4.9-0.8 c-0.4,0-0.8,0-0.3-0.7c1.7-2,2.9-4.4,3.5-6.9c0.4-1.8,0.8-3.7,1-5.6c0.1-1.7-0.1-3.4-0.5-5.1c-0.4-2-0.6-4-1.1-6 c-0.3-0.8-0.3-1.6-0.1-2.4C401.2,192.2,401.7,191.2,402.4,190.3z M393.4,187.6c1-0.5,1.9-1,2.8-1.6c1.6-1,3.4-1.6,5.1-2.4 c0.6-0.3,1.4,0,1.9-0.5l0.1,0.3c-0.4,0.4-0.8,0.7-1.2,1c-1.5,0.9-2.7,2.3-4.2,3.3c-1.7,1.3-3.1,3-3.9,4.9c-0.8,1.6-1.5,3.3-2.3,4.9 c-0.5,1.3-0.9,2.5-1.3,3.9c-0.6,2.4-1.9,4.6-3.6,6.4c-1.2,1.2-2.7,1.9-4.4,2.1c-0.8,0.1-1.5,0.4-2.2,0.7c-1.7,0.6-3.5,1.1-5.2,1.8 c-0.8,0.4-1.6,0.9-2.3,1.5c-0.4,0.4-1.1,0.5-1.6,0.1c-0.6-0.3-0.1-0.8-0.1-1.1c0.5-2.4,1.5-4.7,2.9-6.8c1.4-2.2,2.8-4.4,4-6.7 c1.5-2.5,3.5-4.7,5.9-6.4C386.7,190.5,390.1,189.3,393.4,187.6z M335.6,188.2c0.2,0.5,0.1,1-0.2,1.5c-0.1,0.2-0.2,0.5,0,0.6 c0.7,0.5,0.2,1.1,0.3,1.6c0.4,3,1.1,5.9,2.3,8.7c0.6,1.6,1.4,3.1,2.1,4.6c0.7,1.7,1.7,3.4,2.9,4.8c-0.5,0.2-1,0.2-1.4,0 c-1.7-0.4-3.5-0.3-5.1,0.3c-1.2,0.5-1.8,1.9-1.3,3.1c0,0.1,0,0.1,0.1,0.2c1.1,2.3,3.1,4,4.5,6.1c1.1,1.6,2.2,3.1,3.4,4.7 c-0.5,0.2-1,0.2-1.5,0c-1.9-1.1-4.1-1.8-5.6-3.6c-2.4-2.5-4-5.7-4.6-9.1c-0.3-2.7-0.4-5.5-0.2-8.2c0-2.8,0.5-5.6,1.6-8.2 c0.6-1.3,0.6-3,1.2-4.4c0.2-1.1,0.7-2.2,1.2-3.3c0.4-0.5,1-0.9,1.3-1.6c0,0.6,0.2,1.2-0.7,1.5C335.4,187.7,335.5,188,335.6,188.2z  M341.7,219.8l-0.2-0.3l-0.1-0.1c-0.2-0.2-0.4-0.5-0.5-0.8c-0.1-0.1-0.1-0.2-0.2-0.3l0,0l0,0c0,0-0.1-0.2-0.2-0.3l-0.1-0.1l0,0 l-0.5-0.8l0,0c0,0,0,0,0-0.1l0,0l0,0l0,0c0,0-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.1-0.1-0.2l0,0l0,0c0,0,0,0,0-0.1 c-0.2-0.3-0.4-0.7-0.7-1l-0.4-0.5c-0.5-0.4-0.9-0.8-1.3-1.3c-0.1-0.1-0.1-0.2-0.1-0.2v-0.1v-0.2c-0.1-0.1-0.1-0.3-0.1-0.5 c0.1-0.5,0.5-1,1-1.1c1-0.2,2.1-0.1,3,0.2c1.3,0.1,2.5,0.5,3.7,1.1c2.6,1.1,4.9,2.8,7.6,3.5c1.4,0.3,2.5-0.3,3.8-0.4 c0.2,0,0.4-0.1,0.6-0.1c1.9-0.5,4-0.7,6-0.6l0,0c0.7,0,1.3,0,1.9,0.1c1.5-0.1,3,0.1,4.5,0.5c0.4,0.1,0.8,0.2,1.2,0.3 c0.9,0.1,1.8,0.3,2.6,0.7c1.1,0.5,2.2,1,3.2,1.6c0.6,0.4,0.7,1.1,0.3,1.7c-0.1,0.1-0.1,0.2-0.2,0.2c-2.5,1.7-5.2,3.1-7.8,4.7 c-0.3,0.2-0.5,0.4-0.7,0.6c-0.2,0.1-0.3,0.3-0.5,0.5l-0.2,0.2v0.1l0,0c-0.1,0.1-0.3,0.2-0.4,0.3c-1.7,1.6-3.6,2.9-5.7,4 c-0.6,0.3-1.3,0.4-2,0.5c-1.6,0.2-3.3,0.7-5,0.7c-1.8,0.1-3.5-0.7-4.7-2c-0.6-0.6-1-1.3-1.4-2.1l0,0c-0.2-0.1-0.3-0.3-0.4-0.5 c-0.2-0.3-0.3-0.5-0.5-0.8s-0.3-0.3-0.4-0.5c-0.7-1.2-1.2-2.4-1.9-3.6v-0.1l0,0l-0.2-0.2c-0.1,0-0.1-0.1-0.1-0.2v-0.1l0,0 c0,0-0.1-0.1-0.1-0.2c-0.1,0-0.1-0.1-0.1-0.1l0,0c0,0-0.1-0.1-0.1-0.2l-0.1-0.1C342.8,220.9,342.2,220.4,341.7,219.8z M360.4,212.5 c0.3,0.4,0.7,0.3,1,0l0.7-0.5c0.3-0.2,0.6-0.1,0.8,0.2c0,0,0,0,0,0.1c0.1,0.2,0.2,0.4,0.2,0.7c-0.1,0.3-0.4,0.2-0.7,0.2 c-0.6-0.1-1.2-0.1-1.8,0c-1.3,0.3-1.7-0.3-1.8-1.5c-0.1-1.1-0.1-2.2,0-3.3c0.6,1,1.5,1.6,0.7,3C359.2,211.8,360.1,212,360.4,212.5z  M366.2,212.6c0.2,0.2,0.2,0.5,0,0.7c0,0-0.1,0.1-0.2,0.1c-0.3,0.2-0.8,0.1-0.9-0.3l0,0c-0.9-1.4-1.3-3-1.2-4.7 c0-0.8,0.1-1.5-0.9-1.9c-0.5-0.2-0.4-1.3-0.9-1.9c-0.1-0.1,0-0.4-0.4-0.5c-0.9-0.1-0.9-0.1-0.5-1.4c1.9,2,3.3,4.4,4.1,6.9 C365.5,210.7,365.4,211.8,366.2,212.6z M361.9,208.9c0.2,0.4,0.5-0.1,0.7-0.4s0.3-0.5,0.5-0.3c0.2,0.1,0.3,0.3,0.4,0.5 c0.1,0.3,0,0.6-0.3,0.6c-0.8-0.1-0.6,0.6-0.9,1c-0.2,0.4-0.1,0.5-0.4,0.4c-0.3,0-0.2-0.3-0.3-0.4c0-1-0.3-1.5-1.1-1.8 c-0.6-0.8-0.9-1.8-0.8-2.8c0.1,0,0.2,0,0.3,0c0.3,0.1,0.4,0.5,0.4,0.8C360.2,207.7,361.5,208,361.9,208.9z M360.4,202.9 c-0.2,0.3-0.2,0.7-0.1,1.1c0.1,0.5,0,0.8-0.6,0.7c-0.7,0.2-0.9,0-0.7-0.7c0.2-0.4,0.2-0.9,0.3-1.3c0.1-0.4,0.3-0.6,0.7-0.4 C360.5,202.3,360.6,202.5,360.4,202.9L360.4,202.9z M382.3,177.8c0.3-0.2,0.6,0.1,0.7,0.4c1.8,2.5,3.2,5,2.6,8.2 c0,0.8,0.1,1.7,0.3,2.5c0.1,0.5-0.3,0.6-0.6,0.7c-0.3,0.1-0.3-0.3-0.3-0.4c0-0.6,0-1,0-1.5c0.6-3.5-1-6.3-2.7-9.1 C382.3,178.3,382,178,382.3,177.8L382.3,177.8z M363.6,157.3c-0.2-0.8,0.2-1,0.9-0.9c0.6,0,1.1,0.4,1.4,0.9c1.3,2.5,2.7,4.9,4.4,7.1 c1,1.5,2.4,2.8,3.3,4.3c0.8,1,1.6,1.9,2.6,2.8c2.6,2.7,4.6,5.8,6.2,9.2c0.5,1.2,1.6,2.2,1.8,3.5c0,0.3,0.2,0.5,0.2,0.8 s0.2,0.6-0.2,0.7s-0.4-0.2-0.5-0.4c-1.6-2.7-3.4-5.3-5.5-7.8c-1.3-1.7-2.9-3.1-4.7-4.3c-0.5-0.5-1-1.1-1.5-1.6 c-1.8-1.9-3.8-3.6-5.4-5.6c-1.4-1.6-2.2-3.5-2.6-5.5C363.9,159.5,363.8,158.4,363.6,157.3z M364.2,165.7c0.9,1.4,1.9,2.8,3,4 c2.2,2.1,4.4,4.1,6.6,6.3c1.7,1.7,3.2,3.4,4.6,5.4c1.3,1.3,2.6,2.7,3.7,4.3c0.5,0.6,1,1.4,1.4,2.1l0.4,0.5l0,0l0,0 c0,0.1,0.1,0.2,0.1,0.2c0.1,0.2,0.2,0.3,0.3,0.6c0,0.1,0,0.2,0,0.3l0,0c0,0.1,0,0.2,0,0.3c-0.2,0.5-0.4,0.9-0.7,1.3 c0,0-0.2,0.1-0.3,0.1c-0.1,0,0,0-0.1,0s0,0,0,0s-0.2,0.1-0.3,0.2l0,0c0,0,0,0-0.1,0s-0.1,0.1-0.2,0.1c-0.3,0.3-0.6,0.5-1,0.8 c-0.1,0-0.2,0.1-0.2,0.2l-1.4,0.9l0,0l0,0c-2.3,2.4-4.2,5.1-5.8,8c-1.6,2.6-2.8,5.5-4.3,8.2c-0.4,0.8-0.6,1.6-1,2.5 c-0.4-0.4-0.7-0.9-0.7-1.5c-0.4-3.4-2.5-6-4.5-8.5c-1-1.1-2.1-2.1-3.4-2.8c-1.3-0.9-2.1-0.5-2.4,0.9c-0.6,2.3-1,4.6-1.3,6.9 c-0.3,1.8-0.2,3.7,0.2,5.5c0,0.3,0.2,0.6-0.1,0.7c-0.3,0.1-0.4-0.2-0.5-0.5c-0.4-1.1-0.8-2.3-1-3.4c-0.2-2.5-1.4-4.9-3.3-6.6 c-2.1-1.9-1.5-4-1.3-6.1c0.1-1.4,0.3-2.8,0.6-4.1c1-3.1,2.6-6,4.7-8.5c1.7-2.5,3.3-5,4.6-7.8c1.4-2.6,2.5-5.4,3.3-8.4 C363.8,167.3,364,166.6,364.2,165.7z M356.8,174.8c1.5-2.3,2.7-4.8,3.7-7.3c0.8-1.8,1.3-3.7,1.5-5.6c0-0.1,0.1-0.2,0.3-0.3 c0.3,0.5,0.3,1.1,0.2,1.6c-0.3,1.7-0.8,3.4-1,5.2c-0.4,2.1-1,4.2-1.9,6.2c-0.9,2.1-2,4.1-3.3,5.9c-1,1.3-1.9,2.6-2.6,4 c-0.4,0.7-0.9,1.3-1.4,2c-0.8,1.3-1.3,2.7-2.2,3.9c-0.2,0.2-0.3,0.6-0.7,0.7c0-2,0.4-4.1,1.2-5.9C352.2,181.4,354.3,178,356.8,174.8 z M346,179.7c0-2.1-0.3-4.2-0.3-6.2c0-0.8,0-0.8,0.8-0.5c1.9,0.8,3.5,2.3,4.5,4.1c0.2,0.3,0.4,0.5,0.8,0.6c0.7,0.2,0.7,0.5,0.3,1 c-1.2,1.5-2.3,3.2-3.3,4.9c-0.2,0.3-0.4,0.6-0.6,1C346.6,183.4,345.8,181.5,346,179.7L346,179.7z M342.9,186.7 c0.4-0.6,0.6-1.3,1-1.9c0.4-0.6,0-1.4,0.3-2c0.4,0,0.5,0.2,0.6,0.4c0.6,1.2,1.3,2.4,2,3.6c0.4,0.7,0.6,1.6,0.5,2.5 c-0.1,2.8,0,5.7,0.4,8.5c0.1,0.4,0,0.8-0.4,1.1c-1.9-2.2-3.5-4.7-4.6-7.4c0.6,0.1,1.2,0.1,1.3,0.9c0,0.2,0.2,0.3,0.4,0.2 c0.1-0.1,0.2-0.2,0.1-0.3c0,0,0,0,0-0.1c-0.2-0.5-0.5-0.9-0.9-1.2C341.7,189.5,341.6,188.7,342.9,186.7L342.9,186.7z M338.2,186 c0-0.2,0-0.4,0.3-0.5c1.6,4.2,2.9,8.5,5.6,12.3c1.1,1.5,2.4,2.9,3.5,4.4c1,1.2,2.2,2.1,3.1,3.3c1.1,1.4,1.9,3,2.3,4.7 c0.1,0.8,0.7,1.6,0.5,2.5c0,0.4,0.3,1-0.1,1s-1.3,0.3-1.8,0.1h-0.1c-1.5-0.4-3-1.1-4.2-2.2c-0.9-0.8-1.7-1.6-2.5-2.4 c-0.2-0.1-0.4-0.3-0.5-0.5c-0.1-0.1-0.2-0.3-0.3-0.4l0,0c-2.1-2.7-3.6-5.9-4.3-9.2c-0.1-0.4-0.2-0.7-0.4-1.1c-0.8-2.5-1.2-5-1.2-7.6 C338,188.8,338,187.4,338.2,186L338.2,186z M324.4,184.8c-0.2-3,0.2-6.1-0.6-9.1c-0.1-0.5,0.1-0.8,0.6-0.5c2.9,1.6,6.3,2,9.2,3.8 c0.9,0.5,1.4,1.5,2.4,2c0.2,0,0,0.4,0,0.6c-1,2.3-2,4.5-2.9,6.8c0,0.1-0.1,0.2-0.2,0.3c-0.2,0.7-0.5,1.3-0.8,1.9 c0,1.1-0.3,2.1-1,2.9c-0.3,0.3-0.4,0.7-0.4,1.2c-0.1,1.1-0.6,1.4-1.5,0.7c-0.6-0.4-1.1-0.9-1.5-1.4 C325.7,191.3,324.6,188.1,324.4,184.8L324.4,184.8z M327.1,200.8c-1.1-0.8-2-1.8-2.6-3c0,0,0-0.2-0.1-0.2c-1.6,0.3-1.1-1.2-1.6-1.8 c-1.2-1.8-1.8-4-1.6-6.2c0.1-3.3,0.1-6.6,0.2-9.9c0-0.7,0.1-2.1,0.4-1.9c0.8,0.2,0.2,1.2,0.3,1.9c0.3,2.6-0.5,5.4,0.3,7.9 c0.3,1.5,0.7,3,1.3,4.3c0.5,1.1,1.2,2.2,1.9,3.3c0.7,0.9,1.8,1.6,2.2,2.9c0.1,0.1,0.2,0.2,0.3,0.2c1.5,0,1.5,0.8,1.2,1.9 c-0.3,1.4-0.1,2.9-0.4,4.3c-0.1,0.2-0.1,0.4-0.2,0.6c-0.6-0.4-0.8-1.2-0.7-1.9C328.7,201.7,327.8,201.3,327.1,200.8L327.1,200.8z  M328.7,210.1c0.2,0,0.3,0,0.3,0.2s-0.1,0.3-0.2,0.3h-0.1c-0.7-0.1-1.3,0.2-2.2,0.1C327.1,210.3,327.9,210,328.7,210.1L328.7,210.1z  M317.2,235.8c-3.1-0.2-6.1-1.7-8-4.2c-0.7-0.8-0.7-2,0-2.7c1.6-2.3,3.3-4.5,5.3-6.6c0.5-0.5,0.8-1.1,1.3-1.6c1.6-2,2.8-4.2,5-5.6 c2.1-1.3,4.2-2.5,6.5-3.5c1.4-0.6,1.8-0.3,2.2,1.2c0.5,2,1.4,3.9,2.5,5.6c0.3,0.5,0.6,1,0.8,1.5c0.8,1.5,1.9,2.8,3.3,3.8 c1.3,1.2,2.8,2.1,4.4,2.8c1.4,0.6,2.9,0.9,4.3,1.6c1.1,0.6,1.7,1.7,1.7,2.9c-0.2,1.7-1.2,3.2-2.8,4.1c-1.6,0.7-3.2,1.3-4.9,1.8 c-2.8,0.4-5.6,0.4-8.4,0C325.9,236.4,321.5,236,317.2,235.8L317.2,235.8z M346.5,249.9c0,0.4,0,0.9-0.6,0.9s-0.3-0.6-0.5-1 c0.3-1.2-0.5-2.3-0.5-3.6c-0.1-0.9-0.5-1.7-1.1-2.3c-0.2-0.2-0.5-0.6-0.1-0.8c0.5-0.3,1.1-0.6,1.6-0.7c0.3,0,0.4,0.4,0.4,0.7 c0,1.5,0.4,2.9,1,4.3C346.9,248.3,346.8,249.1,346.5,249.9L346.5,249.9z M342,241.7c-1.4,0.3-2.8,0.5-4.2,0.4c-2.3,0-4.5-0.3-6.7-1 c-1.6-0.5-3.3-0.8-4.9-1.1c-1.8-0.3-3.6-0.9-5.2-1.8c1.5-0.3,3.1-0.2,4.5,0.2c3.3,0.5,6.7,0.8,10,0.7c1.7,0.1,3.5-0.3,5-0.9 c0.7-0.3,1.5-0.3,2.1-0.5c1.6-0.5,3-1.4,4.1-2.7c0.7-0.9,1.8-1,2.6-1.8c0.1-0.2,0.7,0,1,0.3s0.1,0.6,0,0.9c-1.1,2.2-2.8,4-4.9,5.3 C344.4,240.5,343.2,241.1,342,241.7L342,241.7z M348.1,246.3c-0.1-0.3-0.1-0.7-0.2-1.1c-0.4-1.1,0-2.4-0.5-3.7 c-0.1-0.5,0.2-0.7,0.5-0.9c1.6-1.3,3-3,4-4.9c0.6-1.2,1.3-1.2,1.9-0.1c0.6,1.1,1.2,2,1.6,3c0.7,1.3,1.6,2.4,2.8,3.3 c0.6,0.6,1.1,1.2,1.6,1.9c0.4,0.5,0.2,0.8-0.4,0.9c-0.1,0-0.2,0-0.3,0c-2.9-0.4-5.3,1.2-7.7,2.3c-0.4,0.2-0.7,0.3-1.1,0.4 C348.5,248.1,348.4,248,348.1,246.3L348.1,246.3z M359.1,249c-2.5,0.1-4.9,0.6-7.2,1.3c-0.4,0.1-0.7,0.5-1.3,0.7 c0.1-0.7,0.7-0.9,1.1-1.2c1.1-0.9,2.3-1.7,3.5-2.3c1.6-0.8,3.4-0.3,5.1-0.7c0.7,0,1.3-0.3,1.8-0.7c0.5-0.6,0.7-0.6,1.2,0.1 c0.4,0.7,1.6,0.4,2.6,0.9C363.8,248.2,361.4,248.8,359.1,249L359.1,249z M411.2,239.9c-1.2,0.3-2.5,0.5-3.8,0.6 c-1.4,0.4-2.8,0.6-4.2,0.8c-1.7,0.3-3.4,0.7-5,1.2c-2.9,0.7-5.5,2.2-8.3,3.1c-2.4,0.6-4.9,1-7.3,1.1c-3,0.2-6,0.1-9-0.3 c-3.1-0.1-6.2-0.9-9-2.4c-1.5-0.7-2.9-1.7-4.1-2.9c-1.1-1.2-1.7-2.9-1.6-4.5c-0.3,0.4-0.5,0.8-0.9,0.1c-0.1-0.2-0.1-0.4-0.2-0.7 c-1.2-2.3-0.7-2.6,2-2.8c0.2,0,0.5,0,0.7,0.2c3.3,3.4,7.6,5.3,11.9,7.2c3.8,1.4,7.8,2.1,11.9,2c2,0.3,4,0.4,6,0.4 c1.7-0.2,3.3-0.6,4.9-1.3c2.2-1,4.6-2.5,7.1-2.2c1.6,0.2,2.9-0.7,4.4-0.6c1.5,0.1,3.1,0.3,4.7,0.3c0.4,0,0.9,0,0.9,0.3 S411.4,239.7,411.2,239.9L411.2,239.9z M399.1,222.2c1.8,0.1,3.6,0.4,5.3,1c1.4,0.7,2.6,1.7,3.6,2.9c1.6,1.6,3,3.3,4.3,5.2 c0.9,1.5,1.6,3,2.3,4.6c0.4,0.8-0.5,0.6-0.9,0.9c-1.1,0.1-2.2,0-3.3-0.3c-2-0.3-4-0.3-6,0c-3.1,0.3-6.1,0.9-9.1,1.9 c-1.4,0.6-2.9,1-4.4,1.4c-2.6,0.3-5.1,0.2-7.7,0.4c-4,0-7.9-0.9-11.6-2.5c-2.8-0.8-5.3-2-7.6-3.8c-0.3-0.3-0.7-0.5-0.9-0.9 c-0.6-0.7-0.5-1.2,0.3-1.6c0.6-0.3,1.2-0.7,1.6-1.2c0.8-0.6,1.9-0.8,2.8-0.4c3.8,0.8,7.3-0.2,10.9-1.3c3.3-1.2,6.3-2.9,9-5.1 c1.4-0.8,3-1.3,4.7-1.4C394.6,221.7,396.8,221.8,399.1,222.2L399.1,222.2z M399.6,197.9c0.3,2.4,0.4,4.8,0.7,7.1 c0.5,4.1-1.5,7.6-2.9,11.1c-0.6,1.2-1.4,2.3-2.4,3.3c-0.3,0.4-0.9,0.3-1.3,0.3c-0.9,0-1.8,0-2.8,0c1.3-2.4,2-4.9,3.2-7.3 c2.2-4.4,2.8-9.3,4.4-13.9c0.1-0.2,0.1-0.5,0.2-0.8c0.1-0.2,0.1-0.6,0.5-0.6S399.4,197.5,399.6,197.9L399.6,197.9z M397.5,195.3 c-0.2,1-1.1,1.6-1.2,2.8c-0.2,1.5-0.5,3-0.9,4.4c-0.7,2.1-1.4,4.2-2.2,6.3c-0.3,1.3-0.7,2.6-1.3,3.8c-0.7,1.5-1.3,3.1-1.9,4.7 c-0.5,1-1.2,2-2,2.8c-2.4,2.8-5.4,5-8.8,6.4c-2.8,1.2-5.9,1.7-9,1.5c-0.5,0-0.9,0-1.4,0.1c-0.3,0-0.6,0-0.7-0.3s0.2-0.4,0.4-0.6 c1.2-1.4,2.6-2.5,4.3-3.1c1.2-0.5,2.4-1.2,3.5-1.9c1.1-0.5,1.8-1.6,1.8-2.8c0.1-1.4-0.6-2.7-1.9-3.3c-0.6-0.3-1.7-0.5-1.6-1.1 c0.1-0.7,1.2-1.1,2-1.4c0.4-0.1,0.8-0.1,1.2-0.2c2.2-0.8,4.5-0.9,6.6-1.9c4.2-1.9,6.3-5.4,7.7-9.5c1-3.5,2.3-6.8,4-10 c1-1.6,2.3-3,3.8-4.1c1.3-1.1,2.6-2,4.1-3.3c0,0.6-0.2,1.1-0.6,1.5c-1.3,1.4-2.5,2.8-3.6,4.4C398.7,191.9,397.9,193.5,397.5,195.3 L397.5,195.3z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M375.5,220.2c-2.5,1.7-5.2,3.1-7.8,4.7c-0.3,0.2-0.5,0.4-0.7,0.6c-0.2,0.1-0.3,0.3-0.5,0.5l-0.2,0.2v0.1l0,0 c-0.1,0.1-0.3,0.2-0.4,0.3c-1.7,1.6-3.6,2.9-5.7,4c-0.6,0.3-1.3,0.4-2,0.5c-1.6,0.2-3.3,0.7-5,0.7c-1.8,0.1-3.5-0.7-4.7-2 c-0.6-0.6-1-1.3-1.4-2.1l0,0c-0.2-0.1-0.3-0.3-0.4-0.5c-0.2-0.3-0.3-0.5-0.5-0.8s-0.3-0.3-0.4-0.5c-0.7-1.2-1.2-2.4-1.9-3.6v-0.1 l0,0l-0.2-0.2c-0.1,0-0.1-0.1-0.1-0.2v-0.1l0,0c-0.1-0.1-0.1-0.1-0.1-0.2c-0.1,0-0.1-0.1-0.1-0.1l0,0c0,0-0.1-0.1-0.1-0.2l-0.1-0.1 c-0.3-0.4-0.6-0.8-0.9-1.3l-0.2-0.3l-0.1-0.1c-0.2-0.2-0.4-0.5-0.5-0.8c-0.1-0.1-0.1-0.2-0.2-0.3l0,0l0,0c0,0-0.1-0.2-0.2-0.3 l-0.1-0.1l0,0l-0.5-0.8l0,0c0,0,0,0,0-0.1l0,0l0,0l0,0c0,0-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.1-0.1-0.2l0,0l0,0c0,0,0,0,0-0.1 c-0.2-0.3-0.4-0.7-0.7-1l-0.4-0.5c-0.5-0.4-0.9-0.8-1.3-1.3c-0.1-0.1-0.1-0.2-0.1-0.2v-0.1v-0.2c-0.1-0.1-0.1-0.3-0.1-0.5 c0.1-0.5,0.5-1,1-1.1c1-0.2,2.1-0.1,3,0.2c1.3,0.1,2.5,0.5,3.7,1.1c2.6,1.1,4.9,2.8,7.6,3.5c1.4,0.3,2.5-0.3,3.8-0.4 c0.2,0,0.4-0.1,0.6-0.1c1.9-0.5,4-0.7,6-0.6l0,0c0.7,0,1.3,0,1.9,0.1c1.5-0.1,3,0.1,4.5,0.5c0.4,0.1,0.8,0.2,1.2,0.3 c0.9,0.1,1.8,0.3,2.6,0.7c1.1,0.5,2.2,1,3.2,1.6C376.4,219.3,376.1,219.9,375.5,220.2z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M353.6,212.6c0,0.4,0.3,1-0.1,1s-1.3,0.3-1.8,0.1h-0.1c-1.5-0.4-3-1.1-4.2-2.2c-0.9-0.8-1.7-1.6-2.5-2.4 c-0.2-0.1-0.4-0.3-0.5-0.5c-0.1-0.1-0.2-0.3-0.3-0.4l0,0c-2.1-2.7-3.6-5.9-4.3-9.2c-0.1-0.4-0.2-0.7-0.4-1.1c-0.8-2.5-1.2-5-1.2-7.6 c-0.1-1.4-0.1-2.9,0.2-4.3c0-0.2,0-0.4,0.3-0.5c1.6,4.2,2.9,8.5,5.6,12.3c1.1,1.5,2.4,2.9,3.5,4.4c1,1.2,2.2,2.1,3.1,3.3 c1.1,1.4,1.9,3,2.3,4.7C353.2,210.9,353.8,211.7,353.6,212.6z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M335.9,181.6c-1,2.3-2,4.5-2.9,6.8c0,0.1-0.1,0.2-0.2,0.3c-0.2,0.7-0.5,1.3-0.8,1.9c0,1.1-0.3,2.1-1,2.9 c-0.3,0.3-0.4,0.7-0.4,1.2c-0.1,1.1-0.6,1.4-1.5,0.7c-0.6-0.4-1.1-0.9-1.5-1.4c-2-2.7-3.1-5.9-3.3-9.2c-0.2-3,0.2-6.1-0.6-9.1 c-0.1-0.5,0.1-0.8,0.6-0.5c2.9,1.6,6.3,2,9.2,3.8c0.9,0.5,1.4,1.5,2.4,2C336.2,181,336,181.4,335.9,181.6z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M365.8,247.1c-2.1,1.1-4.4,1.7-6.8,1.9c-2.5,0.1-4.9,0.6-7.2,1.3c-0.4,0.1-0.7,0.6-1.3,0.7 c0.1-0.7,0.7-0.9,1.1-1.2c1.1-0.9,2.3-1.7,3.5-2.3c1.6-0.8,3.4-0.3,5.1-0.6c0.7,0,1.3-0.3,1.8-0.7c0.5-0.6,0.7-0.6,1.2,0.1 C363.7,246.9,364.9,246.6,365.8,247.1z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M411.9,239.5c0,0.5-0.6,0.2-0.8,0.3c-1.2,0.3-2.5,0.5-3.8,0.6c-1.4,0.4-2.8,0.6-4.2,0.8c-1.7,0.3-3.4,0.7-5,1.2 c-2.9,0.7-5.5,2.2-8.3,3.1c-2.4,0.6-4.9,1-7.3,1.1c-3,0.2-6,0.1-9-0.3c-3.1-0.1-6.2-0.9-9-2.4c-1.5-0.7-2.9-1.7-4.1-2.9 c-1.1-1.2-1.7-2.9-1.6-4.6c-0.3,0.4-0.5,0.8-0.9,0.1c-0.1-0.2-0.1-0.4-0.2-0.6c-1.2-2.3-0.7-2.6,2-2.8c0.2,0,0.5,0,0.7,0.2 c3.3,3.4,7.6,5.3,11.9,7.2c3.8,1.4,7.8,2.1,11.9,2c2,0.3,4,0.4,6,0.4c1.7-0.2,3.3-0.7,4.9-1.3c2.2-1,4.6-2.5,7.1-2.2 c1.6,0.2,2.9-0.7,4.4-0.6c1.5,0.1,3.1,0.3,4.7,0.3C411.4,239.1,411.9,239.1,411.9,239.5z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M404,184.6c0,0.6-0.2,1.1-0.6,1.5c-1.3,1.4-2.5,2.8-3.6,4.4c-1.1,1.4-2,3.1-2.4,4.8c-0.2,1-1.1,1.6-1.2,2.8 c-0.2,1.5-0.5,3-0.9,4.4c-0.7,2.1-1.4,4.2-2.2,6.3c-0.3,1.3-0.7,2.6-1.3,3.8c-0.7,1.6-1.3,3.2-1.8,4.8c-0.5,1-1.2,2-2,2.8 c-2.4,2.8-5.4,5-8.8,6.4c-2.8,1.2-5.9,1.7-9,1.5c-0.5,0-0.9,0.1-1.4,0.1c-0.3,0-0.5-0.1-0.7-0.3c-0.2-0.4,0.2-0.4,0.4-0.6 c1.2-1.4,2.7-2.4,4.3-3.1c1.2-0.5,2.4-1.2,3.5-1.9c1.1-0.5,1.8-1.6,1.8-2.8c0.1-1.4-0.7-2.7-1.9-3.3c-0.6-0.3-1.6-0.4-1.6-1.1 s1.2-1.1,2-1.4c0.4-0.1,0.8-0.1,1.2-0.3c2.2-0.8,4.5-0.9,6.6-1.9c4.2-1.9,6.3-5.4,7.7-9.5c1-3.5,2.3-6.8,4-10c1-1.6,2.3-3,3.8-4.1 C401.2,186.8,402.6,185.9,404,184.6z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M399.5,197.8c0.3,2.4,0.4,4.7,0.7,7.1c0.5,4.1-1.5,7.6-2.9,11.1c-0.6,1.2-1.4,2.3-2.4,3.3 c-0.3,0.4-0.9,0.2-1.3,0.3c-0.9,0-1.8,0-2.8,0c1.3-2.4,2-4.9,3.2-7.3c2.2-4.4,2.8-9.3,4.4-13.9c0.1-0.2,0.1-0.5,0.2-0.8 s0.1-0.6,0.5-0.6C399.4,197,399.4,197.5,399.5,197.8z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M359.3,244.7c-0.1,0-0.2,0-0.3,0c-2.9-0.4-5.3,1.2-7.7,2.3c-0.3,0.2-0.7,0.3-1.1,0.4c-1.6,0.5-1.8,0.4-2.2-1.3 c-0.1-0.3-0.1-0.7-0.2-1.1c-0.4-1.1-0.1-2.4-0.5-3.7c-0.1-0.5,0.2-0.7,0.6-0.9c1.6-1.3,3-3,3.9-4.9c0.6-1.2,1.3-1.2,1.9-0.1 c0.6,1.1,1.2,2,1.6,3c0.7,1.3,1.6,2.4,2.8,3.3c0.6,0.6,1.1,1.2,1.6,1.9C360.1,244.3,359.9,244.6,359.3,244.7z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M413.7,236.8c-1.1,0.1-2.2,0-3.3-0.3c-2-0.3-4-0.3-6,0c-3.1,0.3-6.1,0.9-9.1,1.9c-1.4,0.6-2.9,1-4.4,1.4 c-2.6,0.3-5.1,0.2-7.7,0.4c-4,0-7.9-0.8-11.6-2.4c-2.8-0.8-5.4-2.1-7.6-3.8c-0.3-0.3-0.6-0.5-0.9-0.8c-0.6-0.7-0.5-1.2,0.3-1.6 c0.6-0.3,1.2-0.7,1.6-1.2c0.8-0.6,1.9-0.8,2.8-0.4c3.8,0.8,7.3-0.2,10.9-1.3c3.3-1.2,6.3-2.9,9-5.1c1.4-0.8,3-1.3,4.7-1.4 c2.2-0.2,4.5-0.1,6.7,0.2c1.8,0.1,3.6,0.4,5.3,1c1.4,0.7,2.6,1.7,3.6,2.8c1.6,1.6,3,3.3,4.3,5.2c0.9,1.5,1.7,3.1,2.4,4.8 C415,236.8,414.1,236.5,413.7,236.8z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M403.4,183.4c-0.4,0.4-0.8,0.7-1.2,1c-1.5,0.9-2.7,2.3-4.2,3.3c-1.7,1.3-3.1,3-3.9,4.9 c-0.8,1.6-1.5,3.3-2.3,4.9c-0.5,1.3-1,2.5-1.3,3.9c-0.6,2.4-1.8,4.6-3.6,6.4c-1.2,1.2-2.7,2-4.4,2.1c-0.8,0.1-1.5,0.4-2.2,0.7 c-1.7,0.6-3.5,1.1-5.2,1.8c-0.8,0.4-1.6,0.9-2.3,1.5c-0.4,0.4-1.1,0.5-1.6,0.1c-0.6-0.3-0.1-0.8-0.1-1.1c0.5-2.4,1.5-4.7,2.9-6.8 c1.4-2.2,2.8-4.4,4-6.7c1.5-2.5,3.5-4.7,5.9-6.4c2.8-2.4,6.3-3.7,9.5-5.3c1-0.5,1.9-1,2.8-1.6c1.7-0.9,3.4-1.7,5.1-2.4 c0.6-0.3,1.3,0,1.9-0.5L403.4,183.4z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M384.2,185.8c-0.2,0-0.4-0.2-0.5-0.4c-1.6-2.7-3.4-5.3-5.5-7.7c-1.3-1.7-2.9-3.1-4.7-4.3 c-0.5-0.5-1-1.1-1.5-1.6c-1.9-1.8-3.7-3.6-5.4-5.6c-1.4-1.5-2.2-3.5-2.6-5.5c0-1.1-0.2-2.2-0.4-3.3c-0.2-0.8,0.2-1,0.9-0.9 c0.6,0,1.1,0.4,1.4,0.9c1.3,2.5,2.7,4.9,4.4,7.2c1,1.5,2.4,2.8,3.3,4.3c0.8,1,1.6,1.9,2.6,2.8c2.6,2.7,4.7,5.8,6.2,9.2 c0.5,1.2,1.6,2.1,1.8,3.5c0,0.3,0.2,0.5,0.2,0.8C384.4,185.3,384.6,185.7,384.2,185.8z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M384.3,189.1c0,0.1,0,0.2,0,0.3l0,0c0,0.1,0,0.2,0,0.3c-0.2,0.5-0.4,0.9-0.7,1.3c0,0-0.2,0.1-0.3,0.1 c-0.1,0,0,0-0.1,0s0,0,0,0s-0.2,0.1-0.3,0.2l0,0c0,0,0,0-0.1,0s-0.1,0.1-0.2,0.1c-0.3,0.3-0.6,0.5-1,0.8c-0.1,0-0.2,0.1-0.2,0.2 l-1.4,0.9l0,0l0,0c-2.3,2.4-4.2,5.1-5.8,8c-1.6,2.6-2.8,5.5-4.3,8.2c-0.4,0.8-0.6,1.6-1,2.5c-0.4-0.4-0.7-0.9-0.7-1.5 c-0.4-3.4-2.5-6-4.5-8.5c-1-1.1-2.1-2.1-3.4-2.8c-1.3-0.9-2.1-0.5-2.4,0.9c-0.6,2.3-1,4.6-1.3,6.9c-0.3,1.8-0.2,3.7,0.2,5.5 c0,0.3,0.2,0.6-0.1,0.7c-0.3,0.1-0.4-0.2-0.5-0.5c-0.4-1.1-0.8-2.3-1-3.4c-0.2-2.5-1.4-4.9-3.3-6.6c-2.1-1.9-1.5-4-1.3-6.1 c0.1-1.4,0.3-2.8,0.6-4.1c1-3.1,2.6-6,4.7-8.5c1.7-2.5,3.3-5,4.6-7.8c1.4-2.6,2.5-5.4,3.3-8.4c0.2-0.7,0.3-1.5,0.6-2.4 c0.9,1.4,1.9,2.8,3,4c2.2,2.1,4.4,4.1,6.6,6.3c1.7,1.7,3.2,3.4,4.6,5.4c1.3,1.3,2.6,2.7,3.7,4.3c0.5,0.6,1,1.4,1.4,2.1l0.4,0.5l0,0 l0,0c0,0.1,0.1,0.2,0.1,0.2C384.3,188.4,384.4,188.8,384.3,189.1z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M362.5,163.1c-0.3,1.6-0.8,3.4-1,5.1c-0.4,2.1-1,4.2-1.9,6.2c-0.9,2.1-2,4.1-3.3,6c-1,1.3-1.9,2.6-2.6,4 c-0.4,0.7-0.9,1.3-1.4,2c-0.8,1.3-1.3,2.7-2.2,3.9c-0.2,0.2-0.3,0.6-0.7,0.7c0-2,0.4-4.1,1.2-5.9c1.7-3.7,3.9-7.1,6.4-10.3 c1.5-2.3,2.8-4.8,3.7-7.4c0.8-1.8,1.3-3.7,1.5-5.6c0-0.1,0.1-0.2,0.3-0.3C362.6,162,362.6,162.6,362.5,163.1z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M352,178.6c-1.2,1.5-2.3,3.2-3.3,4.9c-0.2,0.3-0.4,0.6-0.6,1c-1.5-1.1-2.4-3-2.1-4.9c0-2.1-0.3-4.1-0.3-6.2 c0-0.8,0-0.8,0.8-0.5c2,0.8,3.5,2.3,4.5,4.2c0.2,0.3,0.4,0.5,0.8,0.6C352.4,177.8,352.4,178.2,352,178.6z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M347.3,189.2c-0.1,2.8,0,5.7,0.4,8.5c0.1,0.4,0,0.8-0.4,1.1c-1.9-2.2-3.5-4.7-4.6-7.4c0.6,0.1,1.2,0.1,1.3,0.9 c0,0.2,0.2,0.3,0.4,0.2c0.1-0.1,0.2-0.2,0.1-0.3l0,0c-0.2-0.5-0.5-0.9-0.9-1.2c-1.8-1.5-1.9-2.3-0.7-4.4c0.4-0.6,0.6-1.3,1-1.9 c0.4-0.6,0-1.4,0.3-2c0.4,0,0.5,0.2,0.6,0.4c0.7,1.2,1.2,2.5,2,3.6C347.2,187.5,347.4,188.4,347.3,189.2z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M350.3,234.4c-1.1,2.2-2.8,4-4.9,5.3c-1,0.8-2.2,1.4-3.4,1.9c-1.4,0.3-2.8,0.5-4.2,0.4c-2.3,0-4.5-0.3-6.7-1 c-1.6-0.5-3.3-0.8-4.9-1.1c-1.8-0.3-3.6-0.9-5.2-1.8c1.5-0.3,3.1-0.2,4.5,0.2c3.3,0.5,6.7,0.8,10,0.8c1.7,0.1,3.5-0.3,5-0.9 c0.7-0.2,1.4-0.4,2.2-0.5c1.6-0.5,3-1.4,4.1-2.7c0.7-0.9,1.8-1,2.6-1.8c0.1-0.2,0.7,0,1,0.3C350.6,233.9,350.4,234.2,350.3,234.4z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M335.1,213.6c1.1,2.3,3.1,4,4.5,6.1c1.1,1.6,2.2,3.1,3.4,4.7c-0.5,0.2-1.1,0.2-1.5,0c-1.9-1.1-4.1-1.8-5.6-3.6 c-2.4-2.5-4-5.7-4.6-9.1c-0.3-2.7-0.4-5.5-0.2-8.2c0-2.8,0.5-5.6,1.6-8.2c0.6-1.3,0.6-3,1.2-4.4c0.3-1.1,0.7-2.2,1.2-3.3 c0.4-0.5,1-0.9,1.3-1.6c0,0.6,0.2,1.2-0.7,1.5c-0.3,0.1-0.3,0.4-0.2,0.7c0.2,0.5,0.1,1-0.2,1.4c-0.1,0.2-0.2,0.5,0,0.6 c0.7,0.5,0.2,1.1,0.3,1.6c0.4,3,1.1,5.9,2.3,8.7c0.6,1.6,1.4,3.1,2.1,4.6c0.7,1.7,1.7,3.4,2.9,4.8c-0.5,0.2-1,0.2-1.4,0 c-1.7-0.4-3.5-0.3-5.1,0.3c-1.2,0.5-1.8,1.8-1.3,3.1C335.1,213.5,335.1,213.5,335.1,213.6z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M329.4,199.9c-0.4,1.4-0.1,2.9-0.4,4.3c0,0.2-0.1,0.4-0.2,0.6c-0.6-0.4-0.8-1.2-0.7-1.9c0.6-1.2-0.5-1.6-1-2.1 c-1.1-0.8-2-1.8-2.6-3c0-0.1,0-0.1-0.1-0.2c-1.6,0.3-1.1-1.2-1.6-1.8c-1.2-1.8-1.8-4-1.6-6.2c0.2-3.3,0.1-6.6,0.2-9.9 c0-0.7,0.1-2.1,0.4-1.9c0.8,0.2,0.2,1.2,0.3,1.9c0.3,2.6-0.5,5.4,0.3,7.9c0.2,1.5,0.7,3,1.3,4.3c0.5,1.1,1.2,2.2,1.9,3.3 c0.7,0.9,1.8,1.6,2.2,2.9c0.1,0.1,0.2,0.1,0.3,0.2C329.7,197.9,329.7,198.8,329.4,199.9z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M346.4,230.9c-0.2,1.7-1.2,3.2-2.8,4.1c-1.6,0.7-3.2,1.3-4.9,1.8c-2.8,0.4-5.6,0.4-8.5,0 c-4.3-0.4-8.7-0.8-13.1-1.2c-3.2-0.1-6.1-1.7-8-4.2c-0.7-0.8-0.7-1.9,0-2.7c1.6-2.3,3.3-4.5,5.3-6.6c0.5-0.5,0.8-1.1,1.3-1.6 c1.6-2,2.8-4.2,5-5.6c2.1-1.3,4.2-2.5,6.5-3.5c1.4-0.6,1.8-0.2,2.2,1.2c0.5,2,1.4,3.9,2.5,5.6c0.3,0.5,0.6,1,0.8,1.5 c0.8,1.5,1.9,2.8,3.3,3.8c1.3,1.2,2.8,2.1,4.4,2.8c1.4,0.6,2.9,0.9,4.3,1.6C345.8,228.5,346.5,229.7,346.4,230.9z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M335.9,185.4c-1.2,4.9-1.1,10.3,2.2,14.5c0.5,0.6,1.4-0.3,0.9-0.9c-2.9-3.8-3-8.8-1.9-13.3c0.1-0.3-0.1-0.7-0.4-0.8 C336.4,184.9,336,185.1,335.9,185.4L335.9,185.4L335.9,185.4z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M342.1,185.4c-0.4,1.3-0.6,2.7-0.5,4c0.3,1.2,0.9,2.3,1.8,3.1s1.8,1.8,2.5,2.8c0.7,1.2,1.1,2.5,1.3,3.9c0,0.8,1.3,0.8,1.2,0 c-0.2-2.5-1.3-4.8-3-6.6c-0.9-0.8-1.7-1.7-2.3-2.7c-0.4-1.4-0.4-2.9,0.2-4.3c0.1-0.3-0.2-0.7-0.5-0.7 C342.4,185,342.2,185.2,342.1,185.4L342.1,185.4z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M326.1,195.1c0.8,1.9,2.3,3.5,4.2,4.5c0.3,0.1,0.7-0.1,0.8-0.4c0.1-0.3-0.1-0.7-0.4-0.8l0,0c0.1,0,0,0,0,0h-0.1l-0.3-0.2 L330,198l-0.1-0.1h-0.1c-0.3-0.3-0.7-0.6-0.9-1l-0.1-0.1v-0.1l-0.2-0.3l-0.4-0.6c-0.2-0.4-0.5-0.8-0.7-1.2c-0.2-0.3-0.6-0.4-0.9-0.2 s-0.4,0.5-0.2,0.8L326.1,195.1z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M328.6,196.8c1.8,0.8,3.1-1.8,3.6-3.1c0.5-1.6,1.2-3.2,2.1-4.7c0.4-0.7-0.6-1.3-1.1-0.6c-0.8,1.3-1.4,2.7-1.9,4.1 c-0.2,0.7-0.5,1.3-0.9,1.9c-0.2,0.3-0.4,0.6-0.6,0.9c-0.1,0.1-0.5,0.6-0.7,0.5c-0.3-0.2-0.7-0.1-0.9,0.2 C328.2,196.2,328.3,196.6,328.6,196.8L328.6,196.8z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M321.4,191.2c0.1,2.7,0.8,5.2,2.1,7.5c1.2,2.4,2.6,4.7,4.2,6.9c0.3,0.4,1,0.4,1.1-0.1c0.2-1,0.2-2.1,0.2-3.2 c0-0.7-0.3-1.4-0.8-1.9c-0.3-0.2-0.7-0.3-1.1-0.6c-0.3-0.2-0.6-0.5-0.9-0.9c-0.5-0.7-0.9-1.4-1.3-2c-0.2-0.3-0.5-0.4-0.8-0.2 s-0.4,0.5-0.2,0.8l3.4,6.4c0.4,0.7,1.2,0.2,1.1-0.5L328,201c-0.1-0.8-1.3-0.5-1.2,0.3l0.4,2.4l1.1-0.5l-3.4-6.4l-1,0.6 c0.7,1.2,1.5,2.3,2.5,3.3c0.6,0.4,1.3,0.5,1.4,1.3c0.1,1,0.1,2-0.1,3l1.1-0.1c-1.5-2-2.9-4.2-4-6.5c-1.4-2.2-2.1-4.8-2.2-7.4 C322.6,190.4,321.5,190.4,321.4,191.2L321.4,191.2z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M325,196.4c0.6,0.6,1.3,1.1,1.9,1.6c0.6,0.6,1.3,1,2.1,1.3c0.3,0.1,0.7-0.1,0.8-0.4l0,0 c0.1-0.3-0.1-0.7-0.4-0.8h-0.1l0,0l-0.2-0.1l-0.4-0.3h-0.1l0,0l0,0l-0.2-0.2l-0.5-0.4c-0.6-0.5-1.2-1-1.8-1.5 c-0.2-0.2-0.6-0.2-0.9,0l0,0c-0.2,0.2-0.2,0.6,0,0.9L325,196.4z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M321.4,175.1c0,1.4,0.2,2.7,0.3,4.1c0,1.4,0,2.6-0.1,3.9c-0.3,2.6-0.2,5.1,0.3,7.7c0.1,0.3,0.5,0.5,0.8,0.4 s0.4-0.4,0.4-0.7c-0.5-2.5-0.5-5.1-0.2-7.6c0.1-1.2,0.2-2.5,0.1-3.7c0-1.2-0.3-2.6-0.3-4C322.6,174.3,321.4,174.3,321.4,175.1 L321.4,175.1z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M333.3,197.6c0.4-1.5,0.9-2.9,1.3-4.4c0.1-0.3-0.1-0.7-0.4-0.8l0,0c-0.3-0.1-0.7,0.1-0.8,0.4 c-0.5,1.5-0.9,2.9-1.3,4.4c-0.1,0.3,0.1,0.7,0.4,0.8C332.9,198.1,333.2,197.9,333.3,197.6L333.3,197.6z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M344.3,188.9c-0.3-1.2-0.2-2.5,0.1-3.8c0.3-1.3,0.4-2.6,0.4-3.9l-1.2,0.2c0.3,1.2,0.6,2.4,1.1,3.5 c0.2,0.6,0.4,1.1,0.7,1.6c0.3,0.5,0.4,1.1,0.2,1.6c-0.2,0.8,0.9,1.1,1.2,0.3c0.2-1.2-0.1-2.5-0.8-3.6c-0.5-1.2-0.9-2.5-1.2-3.8 c-0.2-0.7-1.3-0.5-1.2,0.2c0.3,2.7-1.2,5.3-0.4,8c0.1,0.3,0.4,0.5,0.8,0.4C344.2,189.6,344.4,189.2,344.3,188.9L344.3,188.9z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M357.8,233.6c-0.5-0.1-1,0-1.4,0.4c-0.2,0.2-0.2,0.5-0.1,0.8c0.6,1.2,0.8,2.6,1.5,3.8c0.5,1,1.2,1.9,2.1,2.7 c1.7,1.6,3.9,2.5,6.2,2.7c0.8,0,0.8-1.2,0-1.2c-3.1-0.2-5.9-2.1-7.4-4.9c-0.6-1.2-0.8-2.5-1.4-3.7l-0.1,0.7c0,0,0,0,0.2,0 c0.3,0.1,0.7-0.2,0.7-0.5C358.2,234,358.1,233.7,357.8,233.6L357.8,233.6z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M358,236.3c-0.1,0.5,0.1,1,0.5,1.3c0.2,0.3,0.5,0.7,0.8,1c0.2,0.2,0.6,0.2,0.9,0c0.2-0.2,0.2-0.6,0-0.9l0,0 c-0.2-0.2-0.4-0.4-0.6-0.7l0.1,0.1c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1-0.1-0.2-0.3-0.2-0.4v0.1v-0.1v0.2v-0.1v0.2l0,0 c0.1-0.3,0-0.7-0.3-0.8l0,0C358.5,235.8,358.2,236,358,236.3L358,236.3z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M384.1,245l1.2,0.1c1.6,0.1,1.6-2.3,0-2.5c-1.5-0.1-3-0.1-4.4,0c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2 c2.2,0.1,4.4,0,6.6-0.2c1-0.1,1.9-0.2,2.9-0.5c0.8-0.4,1.6-0.7,2.4-0.9c4-1.2,8.1-2,12.2-2.4c1.6-0.2,1.6-2.6,0-2.5 c-4.1,0.4-8.1,1.2-12,2.3c-1.8,0.7-3.6,1.2-5.5,1.6c-2.2,0.2-4.4,0.3-6.6,0.2v2.5c1.5-0.1,3-0.1,4.4,0v-2.5l-1.2-0.1 C382.5,242.4,382.5,244.9,384.1,245L384.1,245z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M404.9,239.8c2.5,0.2,4.9,0.3,7.4,0.4c0.8,0,0.8-1.2,0-1.2c-2.5-0.1-4.9-0.2-7.4-0.4 C404.1,238.5,404.1,239.7,404.9,239.8z"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M367.6,167.2c0.8,1.3,1.9,2.4,3,3.4c1.3,1.2,2.5,2.4,3.8,3.6c2.5,2.5,4.9,5,7.2,7.6c0.5,0.6,1.4-0.3,0.9-0.9 c-2.3-2.6-4.6-5.1-7-7.5c-1.2-1.2-2.4-2.3-3.6-3.4c-1.3-1-2.4-2.2-3.3-3.5C368.2,165.9,367.2,166.6,367.6,167.2L367.6,167.2z"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M397.6,191.6c-1.3,4.1-2.8,8.2-4.4,12.3c-0.3,0.7,0.9,1.1,1.2,0.3c1.6-4,3.1-8.1,4.4-12.3 C399,191.2,397.8,190.9,397.6,191.6z"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M308.4,233.6c-1-0.8-1.5-2.2-1.3-3.5c0.2-0.6,0.5-1.2,0.8-1.7l1.1-1.8c1.5-2.4,3.4-4.6,5.5-6.6c0.6-0.5-0.3-1.4-0.9-0.9 c-1.2,1.2-2.4,2.4-3.5,3.7c-1,1.3-1.9,2.7-2.7,4.1c-0.9,1.1-1.5,2.5-1.6,4c0,1.4,0.6,2.7,1.6,3.7c0.6,0.5,1.5-0.4,0.9-0.9 L308.4,233.6z"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M326.5,211h2.4c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6h-2.4c-0.3,0.1-0.6,0.4-0.5,0.7C326,210.8,326.2,211,326.5,211z"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M316.1,220.1c2-2.4,4.2-4.7,6.6-6.7c0.2-0.2,0.2-0.6,0-0.9c-0.2-0.2-0.6-0.2-0.9,0c-2.4,2.1-4.6,4.3-6.6,6.7 C314.7,219.8,315.6,220.7,316.1,220.1z"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M338.1,214.8c-0.4-0.4-0.7-1-0.9-1.5c-0.2-0.5-0.1-1,0.1-1.4v-0.1c0-0.1,0.1-0.1,0.1-0.1c0.1-0.1,0.3-0.2,0.4-0.2 c0.3-0.1,0.6-0.2,0.9-0.2c0.7,0,1.4,0,2.2,0.1c0.3,0.1,0.7-0.1,0.8-0.4c0.1-0.3-0.1-0.7-0.4-0.8l0,0c-1.6-0.2-3.9-0.5-4.9,1.1 c-0.4,0.7-0.5,1.5-0.3,2.3c0.3,0.8,0.7,1.5,1.3,2.1c0.2,0.2,0.6,0.2,0.9,0C338.4,215.4,338.4,215,338.1,214.8L338.1,214.8 L338.1,214.8z"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M350.8,176.4c0.3,0.7,0.8,1.3,1.3,1.9c0.2,0.2,0.6,0.2,0.8,0c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.2,0.1-0.3,0-0.5 c-0.3-0.4-0.6-0.8-0.8-1.2c-0.1-0.3-0.5-0.5-0.8-0.3c-0.3,0.1-0.5,0.5-0.3,0.8c0,0.1,0.1,0.1,0.1,0.1c0.2,0.4,0.5,0.8,0.8,1.2l1-0.8 c-0.1-0.1-0.3-0.3-0.4-0.4v0.1c-0.3-0.4-0.6-0.8-0.8-1.3c-0.2-0.3-0.5-0.4-0.8-0.2l0,0c-0.1,0.1-0.2,0.2-0.3,0.4 C350.7,176.1,350.7,176.2,350.8,176.4L350.8,176.4z"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M342.6,169.9c-1.2,2.6,0,5.4-0.2,8.2c0,3-0.7,5.9-2,8.6c-0.1,0.3,0,0.7,0.3,0.8s0.6,0,0.7-0.2c1.2-2.5,1.9-5.2,2.1-7.9 c0.2-1.5,0.2-3,0-4.4c-0.3-1.4-0.3-3,0.2-4.4C344.1,169.8,343,169.2,342.6,169.9L342.6,169.9z"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M323.6,241.3c3.3,0.6,6.4,2.3,9.8,2.3c0.3-0.1,0.6-0.4,0.5-0.7c0-0.3-0.2-0.5-0.5-0.5c-3.3,0-6.3-1.6-9.5-2.3 C323.1,239.9,322.8,241.1,323.6,241.3z"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M339.2,238.6l1.9-0.6l-0.5-1.1c-0.7,0.4-1.6,0.7-2.4,0.8l0.2,1.2c2.2-0.4,4.4-1,6.4-2c1.8-1.1,3.4-2.4,4.9-3.9 c0.6-0.6-0.3-1.4-0.9-0.9c-1.4,1.5-3,2.7-4.7,3.8c-1.9,0.9-4,1.6-6.1,1.9c-0.7,0.1-0.5,1.3,0.2,1.2c1.1-0.1,2.1-0.4,3-1 c0.3-0.2,0.4-0.6,0.2-0.9c-0.1-0.2-0.4-0.3-0.7-0.3l-1.9,0.6C338.1,237.7,338.4,238.9,339.2,238.6L339.2,238.6z"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M354,235.8c1.1,3.1,2.8,5.9,5.1,8.2c2.2,1.8,4.8,3.1,7.7,3.6c0.8,0.2,1.1-1,0.3-1.2c-2.7-0.5-5.2-1.7-7.3-3.4 c-2.1-2.2-3.7-4.8-4.7-7.7C354.7,234.6,353.7,235.2,354,235.8L354,235.8z"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M335,179L335,179c0.1,0,0.2,0,0.2,0H335l0.4,0.2l-0.1-0.1c0.2,0.2,0.4,0.4,0.6,0.6l0.7,0.8c0.2,0.2,0.6,0.2,0.9,0 c0.2-0.2,0.2-0.6,0-0.9c-0.3-0.4-0.6-0.7-1-1.1c-0.3-0.4-0.8-0.7-1.4-0.7c-0.3,0-0.6,0.3-0.6,0.6S334.8,179,335,179L335,179z"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M334.4,178.7c0.2,0,0.3,0.1,0.5,0.1h-0.1c0.2,0.1,0.3,0.1,0.4,0.2l0.1,0.1l0,0l0,0l0.2,0.1c0.3,0.2,0.5,0.5,0.7,0.7 s0.6,0.2,0.9,0l0,0c0.2-0.2,0.2-0.6,0-0.9c-0.6-0.8-1.4-1.4-2.3-1.6c-0.2-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.2,0.2-0.3,0.4 C333.9,178.3,334.1,178.6,334.4,178.7L334.4,178.7z"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M381.9,178.1c1.2,1.8,2.1,3.7,2.6,5.8c0.3,1,0.3,2.1,0.2,3.1c-0.3,0.9-0.3,1.9,0,2.9c0.2,0.3,0.5,0.4,0.8,0.2l0,0 c0.4-0.2,0.8-0.6,0.9-1.1c0.1-0.8-1-1.1-1.2-0.3c0,0.2-0.1,0.3-0.3,0.4l0.8,0.2c-0.1-0.5-0.1-1.1,0-1.6s0.1-0.9,0.1-1.4 c0-1-0.2-2-0.4-3c-0.6-2-1.5-3.9-2.6-5.7c-0.4-0.7-1.5,0-1.1,0.6L381.9,178.1z"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M385.5,180.2c0.8,2.6,1.6,5.3,2.2,8c0.1,0.3,0.5,0.5,0.8,0.4s0.4-0.4,0.4-0.7c-0.7-2.7-1.4-5.3-2.2-8 C386.4,179.1,385.2,179.4,385.5,180.2L385.5,180.2z"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M382.8,180.4c0,0.6,0.1,1.3,0.5,1.8c0.2,0.5,0.4,1.1,0.5,1.6l0.3,1.6c0,0.3,0.1,0.6,0.3,0.8c0.2,0.3,0.6,0.5,1,0.3l0,0 c0.7-0.4,0-1.5-0.6-1.1l0,0h0.5l0,0l0.3,0.2c0,0.2,0,0.2,0,0v-0.2c0-0.1,0-0.2,0-0.3c0-0.2-0.1-0.4-0.1-0.7 c-0.1-0.5-0.2-0.9-0.3-1.4c-0.1-0.4-0.2-0.9-0.4-1.3c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.1-0.1-0.3-0.2-0.5c0.1-0.3-0.1-0.7-0.4-0.8 s-0.7,0.1-0.8,0.4l0,0L382.8,180.4z"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M403.7,183.7c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6l0,0c-0.3,0-0.6,0.3-0.6,0.6S403.3,183.7,403.7,183.7z"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M369.9,212.1c0.1,1,0.5,2.3,1.8,2.5c0.5,0,1.1-0.1,1.5-0.4c0.7-0.3,1.4-0.7,2.2-1c2.8-1.1,5.7-1.7,8.4-2.7 c2.4-0.7,4.5-2.3,5.9-4.4c1.4-2.7,2.5-5.5,3.4-8.3c0.3-0.8-0.9-1.1-1.2-0.3c-0.8,2.4-1.7,4.7-2.7,7c-1,2.1-2.8,3.8-5,4.6 c-2.1,0.9-4.3,1.4-6.6,2.1c-1.1,0.4-2.3,0.8-3.4,1.2l-1.3,0.6c-0.5,0.3-1,0.3-1.5,0c-0.2-0.2-0.2-0.9-0.3-1.2 C371,210.9,369.8,211.3,369.9,212.1L369.9,212.1z"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M386.7,241.8c2.2,0.2,4.5-0.1,6.6-1l-0.5-1.1c-1.6,0.8-3.3,1.3-5.1,1.4c-0.8,0.1-0.8,1.3,0,1.2c2.1-0.2,4.3-0.6,6.3-1.2 c2-0.7,4-1.8,6.1-2.3c0.3-0.1,0.5-0.5,0.4-0.8s-0.4-0.4-0.7-0.4c-2,0.5-3.9,1.6-5.8,2.2c-2,0.7-4.1,1.1-6.2,1.3v1.2 c2-0.1,3.9-0.7,5.7-1.5c0.6-0.3,0.2-1.4-0.5-1.1c-2,0.8-4.1,1.1-6.2,1C385.9,240.6,385.9,241.7,386.7,241.8L386.7,241.8z"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M410.1,238c1.3,0.2,2.6,0.1,3.9-0.2c0.6-0.1,1.1-0.4,1.5-0.9c0.2-0.5,0.3-1.1,0.3-1.6c0-0.8-1.3-0.8-1.2,0 c0,0.2,0,0.4,0,0.6c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.1-0.2,0.2-0.3,0.2c-0.3,0.1-0.5,0.1-0.8,0.2c-1,0.2-2.1,0.2-3.2,0.1 c-0.3,0-0.6,0.3-0.6,0.6C409.5,237.7,409.8,238,410.1,238L410.1,238z"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M393.1,209.6c-0.6,1.6-1.2,3.2-1.9,4.8l1.2,0.3c0.4-1.7,1.1-3.4,2.1-4.9c0.2-0.3,0.1-0.7-0.2-0.8l0,0 c-0.3-0.2-0.7-0.1-0.9,0.2c-1,1.6-1.8,3.4-2.2,5.2c-0.1,0.3,0.1,0.7,0.4,0.8l0,0c0.3,0.1,0.7-0.1,0.8-0.4c0.6-1.6,1.3-3.2,1.9-4.8 c0.1-0.3-0.1-0.7-0.4-0.8S393.2,209.3,393.1,209.6L393.1,209.6z"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M322.4,200.1c1.6,3.4,3.8,6.4,6.6,8.9c0.2,0.2,0.6,0.2,0.9,0c0.2-0.2,0.2-0.6,0-0.9c-2.7-2.4-4.8-5.4-6.3-8.6 C323.2,198.8,322.1,199.4,322.4,200.1L322.4,200.1z"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M365.9,155.4c3.4,5.1,6.7,10.4,11.1,14.7c2.1,2.1,4.5,4.1,6.6,6.3c1.1,1.1,1.9,2.4,2.4,3.9c0.4,1.5,0.7,3,0.7,4.6 c0,0.8,1.3,0.8,1.2,0c0-2.8-0.8-5.6-2.3-8c-2-2.4-4.2-4.6-6.6-6.6c-4.8-4.6-8.3-10.1-12-15.5C366.5,154.1,365.5,154.8,365.9,155.4 L365.9,155.4z"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M350.3,192c0.7-1.7,1.7-3.3,2.8-4.7l3.5-5c0.5-0.7-0.6-1.3-1.1-0.6l-3.6,5.2c-1.2,1.5-2.1,3.2-2.8,4.9 C348.8,192.5,350,192.8,350.3,192L350.3,192z"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M311.9,236.4c1.4,0.6,2.8,1.4,4.1,2.2c1.3,0.6,2.6,1.1,4,1.4c3.1,0.9,6.3,1.9,9.5,2.8c5.4,1.6,11.7,2.9,16.7-0.7 c0.6-0.5,0-1.5-0.6-1.1c-5,3.7-11.5,1.9-16.9,0.3l-8.7-2.6c-1.5-0.4-3-1-4.4-1.7c-1.1-0.7-2.2-1.3-3.4-1.8 C311.5,235,311.2,236.2,311.9,236.4L311.9,236.4z"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M307.7,234.3c2.6,1.5,5.3,2.8,8,4.1c0.3,0.2,0.7,0.1,0.8-0.2c0.2-0.3,0.1-0.7-0.2-0.8l0,0c-2.7-1.3-5.4-2.6-8-4.1 c-0.3-0.2-0.7-0.1-0.8,0.2C307.3,233.7,307.4,234.1,307.7,234.3L307.7,234.3z"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M353.6,176.9c3.1-1.8,4.3-5.3,5.6-8.5c1.4-3.6,2.5-7.4,3.3-11.2c0.1-0.8-1-1.1-1.2-0.3c-0.7,3.5-1.6,6.9-2.8,10.2 c-1.2,3.1-2.4,7-5.4,8.8c-0.3,0.2-0.3,0.6-0.1,0.9C353.1,176.9,353.4,177,353.6,176.9L353.6,176.9z"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M353.8,176.7c2.8-3.1,5-6.7,6.4-10.6c0.3-0.8-0.9-1.1-1.2-0.3c-1.4,3.7-3.4,7.1-6.1,10.1 C352.4,176.4,353.2,177.3,353.8,176.7z"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M344.1,179.6c0.3,3.4,1.5,6.6,3.5,9.3c0.5,0.6,1.4-0.3,0.9-0.9c-1.8-2.5-2.9-5.4-3.1-8.5c0-0.3-0.3-0.6-0.6-0.6 C344.4,179,344.1,179.3,344.1,179.6z"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M343,179.6c-0.3,2.2-0.7,4.3-1.2,6.4c-0.2,0.8,1,1.1,1.2,0.3c0.5-2.2,0.9-4.5,1.2-6.7c0-0.3-0.3-0.6-0.6-0.6 S343,179.3,343,179.6L343,179.6z"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M370.9,167.9c3.1,2.4,6,5,8.6,7.9c2.8,3.1,4.7,7,5.4,11.1c0.1,0.8,1.3,0.4,1.2-0.3c-1.5-8.6-7.9-14.3-14.3-19.7 C371.2,166.4,370.3,167.3,370.9,167.9L370.9,167.9z"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M380.1,177.3c1.6,1.9,2.7,4,3.3,6.4c0.3,1.8,1.3,3.5,2.6,4.7c0.4,0.3,0.9-0.1,0.9-0.5c0.1-4.4-1.4-8.7-4.2-12.1 c-2.9-3.1-6.4-5.8-10.1-7.9c-0.7-0.4-1.3,0.6-0.6,1.1c3.5,2,6.7,4.4,9.4,7.3c2.9,3.2,4.4,7.4,4.3,11.7l0.9-0.5 c-1.6-1.3-1.9-3.7-2.6-5.6c-0.6-2-1.7-3.8-3.1-5.4C380.4,175.9,379.5,176.7,380.1,177.3L380.1,177.3z"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M382.1,178.4l0.5,0.3l0,0l0.1,0.1l0.2,0.2c0.1,0.1,0.3,0.3,0.4,0.4l0.2,0.2l0,0l0.1,0.1c0.2,0.3,0.4,0.7,0.6,1 l0,0v0.1l0.1,0.3c0,0.2,0.1,0.4,0.1,0.6c0.1,0.3,0.4,0.5,0.8,0.4c0.3-0.1,0.5-0.4,0.4-0.8c-0.4-1.8-1.5-3.4-3.1-4.3 c-0.3-0.2-0.7-0.1-0.9,0.2c-0.2,0.3-0.1,0.7,0.2,0.9L382.1,178.4z"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M367.1,162.5c2.8,3.3,5.7,6.5,8.8,9.4c0.6,0.5,1.4-0.3,0.9-0.9c-3.1-2.9-6.1-6.1-8.8-9.4 C367.5,161.1,366.6,161.9,367.1,162.5L367.1,162.5z"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M372.6,165.9c1.9,4.2,6.1,6.6,9.3,9.6c3.7,3.5,4.8,8.2,5,13.1c0,0.8,1.3,0.8,1.2,0c-0.2-4.7-1.2-9.4-4.4-13 c-3.3-3.6-8-5.8-10.1-10.3C373.3,164.5,372.3,165.1,372.6,165.9L372.6,165.9z"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M328.6,210.9c0.2,2.3,1.1,4.6,2.4,6.6c0.9,1.9,2.3,3.6,4,4.9c0.7,0.4,1.3-0.6,0.6-1.1c-1.5-1.2-2.8-2.7-3.6-4.4 c-1.2-1.8-2-3.8-2.2-5.9c-0.1-0.3-0.4-0.6-0.7-0.5C328.8,210.5,328.6,210.7,328.6,210.9L328.6,210.9z"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M338.8,224.4c1.3,0.5,2.7,0.8,4.2,0.9c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-1.3-0.1-2.6-0.4-3.8-0.9 c-0.3-0.1-0.7,0.1-0.8,0.4l0,0C338.3,224,338.5,224.3,338.8,224.4L338.8,224.4z"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M335.6,193.5c0.6,6.3,3,12.3,6.9,17.3c0.5,0.6,1.3-0.3,0.9-0.9c-3.7-4.8-6-10.5-6.6-16.5 C336.8,192.8,335.5,192.7,335.6,193.5L335.6,193.5z"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M329.7,206.5c0.4-3.1,0.9-6.1,1.6-9.2c0.2-0.8-1-1.1-1.2-0.3c-0.7,3.1-1.2,6.3-1.6,9.5c0,0.3,0.3,0.6,0.6,0.6 C329.4,207.1,329.7,206.8,329.7,206.5L329.7,206.5z"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M370.6,212.5c0.7-4.2,2.9-7.7,5.2-11.2c2-3.3,4.6-6.2,7.6-8.7c6.1-4.4,13.1-7.3,20.6-8.5c1.6-0.3,0.9-2.7-0.7-2.4 c-7.9,1.2-15.3,4.4-21.7,9.1c-3.1,2.5-5.7,5.5-7.8,8.9c-2.4,3.7-4.9,7.6-5.6,12.1C368,213.4,370.4,214,370.6,212.5L370.6,212.5z"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M425.2,435.7c0,0,12.9-1.9,17.9-6.6s13.3-14.6,16.9-14.6c-3.3,2.6-6.3,5.5-9.1,8.6c-2.2,3-9,14.1-20.4,13.3 c0,0-4.4,0-4.1,2.1C426.7,440.6,424.9,436.6,425.2,435.7z"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M522.4,202c0,0-34.6,19.8-39,31.1l-4.4,11.5c0,0,0.9-11.3,8.7-19c7.8-7.7,21.1-16.9,22.6-18s8.4-5.7,8.4-5.7 L522.4,202z"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M562.3,206.9c0,0-2.9,28.8-11.5,36.6c3.1-3.2,5.5-7.1,7.2-11.2c1.9-5.8,5.9-23.3,9.1-23.5 S562.3,206.9,562.3,206.9z"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M250.6,326.6c0,0,16.4,0.7,23.1,6.6c-6.9-5.3-15.4-8.2-24.1-8C234.6,325.2,250.6,326.6,250.6,326.6z"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M217.2,315.6c0,0-12.7-10.4-14.6-19.1c2.3,8.4,7.4,15.7,14.5,20.8C229.3,326.3,217.2,315.6,217.2,315.6z"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M252.7,328.7c0,0,13.6,9.2,16.2,17.7c-3.1-8.1-8.9-15-16.4-19.4C239.7,319.1,252.7,328.7,252.7,328.7z"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M250.5,320.3c0,0,44.2,4.9,56.1-5.1c0,0-11.2,7.7-53.9,3.8C236.8,317.6,250.5,320.3,250.5,320.3z"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M237.2,299.8c0,0-3.1-28.1,8.6-31.6c0,0-8,1-9.8,14.2c-1.1,8.7-1.1,17.5,0,26.2L237.2,299.8z"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M203.1,313c0,0-5.3-1.1-11.6-10.3c0,0,6,12.7,15.7,15.1L203.1,313z"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M211.3,335.8c0,0,3.1-5.3,12.1-8c9-2.8,25.2-3.5,25.2-3.5l2-6.6l6,1.9c-1.3,2.3-2.1,4.9-2.2,7.6c-0.1,1.2-1.1,2.1-2.3,2 c-2.2,0.2-6.6,0.3-8.9,0.7S224.2,331.2,211.3,335.8z"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M530.2,395.2c0,0,40-16.1,38.6-43.5s2.2-5.4,2.2-5.4s10.4,45.1-42.4,57.7L530.2,395.2z"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M351,359.7c0,0-11.6,4.1-9.9-8.5s6.4-27.2,9.9-27.3c0,0-2.8,0.1-5,5.4s-6.2,20-6.3,23.7 c-0.1,3.7,0.2,7.7,3.3,9.3c2.3,1,4.9,1.5,7.4,1.6L351,359.7z"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M420.7,355.6c0,0,2.2-29.3,3.3-31s16.1-12.5,16.1-12.5s-3.1,4.2-5.6,7.2c-2.5,3.1-1.6,10-4.2,13.1 c-2.5,3.1-4.7,5.6-5.8,9.2S420.7,355.6,420.7,355.6z"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M372.4,402.4c0,0,9.4,1.1,14.4-1.9c4.9-3.3,8.8-8,11-13.4c2.1-5,4.9-5.6,4.9-5.6c-1.9,2-3.1,4.6-3.5,7.4 c-0.4,4.4-0.8,15-4.3,17.6c-3.5,2.5-10.8,5.9-11.5,6.4c-1.8,1.5-2.8,5.9-1,8.2c1.9,2.3-10.9-9.6-10.9-9.6L372.4,402.4z"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M496.4,242.8c1.4-6.4,5.3-11.9,10.9-15.3c9.6-6.1,9.2-4,18.4-9.4s12.3-6.1,16.8-14.2c4.6-8,8-14.5,11.5-14.9 c3.4-0.4,4,1.3,5.2,5.2c1.1,3.8,2.1,9.6,0.8,19.5c-1.3,10-9,26.2-9,26.2"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M422.7,394.1c0,0,59.3-71.1,110.6-67.1C533.3,326.9,481.5,326.7,422.7,394.1z"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M426.5,395.3c0,0,68-62.8,118.4-52.2C544.9,343,493.4,336.1,426.5,395.3z"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M431.4,396.9c0,0,64.2-52.2,108.6-39.9C539.9,357,494.5,347.9,431.4,396.9z"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M687.9,358.9c0,181.7-147.3,329-329.1,329c-154.5,0-284.2-106.6-319.5-250.2c-10.6-43.3-12.3-88.3-5.2-132.3 C59.8,149,195.5,29.9,358.9,29.9C540.7,29.9,687.9,177.2,687.9,358.9z"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M220.7,603.7h-2.8l-1.1-2.8h-5.1l-1.1,2.8h-2.8l5-12.2h2.7L220.7,603.7z M215.9,598.9l-1.8-4.5l-1.7,4.5H215.9z"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M239.3,599.7l2.5-0.2c0.2,0.8,0.5,1.4,0.9,1.8c0.5,0.4,1.1,0.6,1.9,0.6c0.8,0,1.5-0.2,1.9-0.5s0.6-0.7,0.6-1.2 c0-0.3-0.1-0.5-0.3-0.7s-0.5-0.4-0.9-0.5c-0.3-0.1-1-0.3-2.1-0.5c-1.4-0.3-2.4-0.7-2.9-1.2c-0.8-0.7-1.2-1.5-1.2-2.5 c0-0.6,0.2-1.2,0.6-1.7c0.4-0.5,0.9-1,1.6-1.2c0.7-0.3,1.5-0.4,2.5-0.4c1.6,0,2.8,0.3,3.6,1s1.2,1.6,1.3,2.7l-2.6,0.1 c-0.1-0.6-0.3-1.1-0.7-1.4c-0.4-0.3-0.9-0.4-1.6-0.4c-0.8,0-1.3,0.1-1.8,0.4c-0.3,0.2-0.4,0.4-0.4,0.8c0,0.3,0.1,0.5,0.4,0.7 c0.3,0.3,1.1,0.5,2.4,0.8c1.3,0.3,2.2,0.6,2.8,0.9c0.6,0.3,1.1,0.7,1.4,1.2c0.3,0.5,0.5,1.2,0.5,1.9s-0.2,1.4-0.6,2 c-0.4,0.6-1,1.1-1.7,1.4c-0.7,0.3-1.7,0.4-2.8,0.4c-1.6,0-2.9-0.4-3.7-1.1C240,602.1,239.5,601.1,239.3,599.7z"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M269.2,599.7l2.5-0.2c0.2,0.8,0.5,1.4,0.9,1.8c0.5,0.4,1.1,0.6,1.9,0.6s1.5-0.2,1.9-0.5s0.6-0.7,0.6-1.2 c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.5-0.4-0.9-0.5c-0.3-0.1-1-0.3-2.1-0.5c-1.4-0.3-2.4-0.7-2.9-1.2c-0.8-0.7-1.2-1.5-1.2-2.5 c0-0.6,0.2-1.2,0.6-1.7s0.9-1,1.6-1.2c0.7-0.3,1.5-0.4,2.5-0.4c1.6,0,2.8,0.3,3.6,1c0.8,0.7,1.2,1.6,1.3,2.7l-2.6,0.1 c-0.1-0.6-0.3-1.1-0.7-1.4c-0.4-0.3-0.9-0.4-1.6-0.4c-0.8,0-1.3,0.1-1.8,0.4c-0.3,0.2-0.4,0.4-0.4,0.8c0,0.3,0.1,0.5,0.4,0.7 c0.3,0.3,1.1,0.5,2.4,0.8s2.2,0.6,2.8,0.9c0.6,0.3,1.1,0.7,1.4,1.2s0.5,1.2,0.5,1.9s-0.2,1.4-0.6,2s-1,1.1-1.7,1.4 c-0.7,0.3-1.7,0.4-2.8,0.4c-1.6,0-2.9-0.4-3.7-1.1C269.9,602.1,269.4,601.1,269.2,599.7z"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M299.3,597.7c0-1.2,0.2-2.3,0.6-3.1c0.3-0.6,0.7-1.2,1.2-1.7s1.1-0.9,1.7-1.1c0.8-0.3,1.7-0.5,2.8-0.5 c1.9,0,3.4,0.6,4.5,1.7s1.7,2.7,1.7,4.7s-0.6,3.5-1.7,4.6s-2.6,1.7-4.5,1.7s-3.4-0.6-4.6-1.7C299.8,601.1,299.3,599.6,299.3,597.7z  M301.9,597.6c0,1.4,0.3,2.4,1,3.2c0.7,0.7,1.5,1.1,2.6,1.1c1,0,1.9-0.4,2.5-1.1c0.7-0.7,1-1.8,1-3.2s-0.3-2.4-1-3.1 c-0.6-0.7-1.5-1-2.6-1s-1.9,0.3-2.6,1C302.3,595.1,301.9,596.2,301.9,597.6z"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M339.9,599.2l2.5,0.8c-0.4,1.3-1,2.3-1.9,3c-0.9,0.6-2,1-3.4,1c-1.7,0-3.1-0.6-4.2-1.7c-1.1-1.1-1.6-2.6-1.6-4.5 c0-2,0.6-3.6,1.7-4.7s2.6-1.7,4.4-1.7c1.6,0,2.8,0.4,3.8,1.3c0.6,0.5,1,1.3,1.3,2.3l-2.6,0.6c-0.2-0.6-0.5-1.1-1-1.5 s-1.1-0.6-1.8-0.6c-1,0-1.7,0.3-2.3,1c-0.6,0.7-0.9,1.7-0.9,3.2s0.3,2.6,0.9,3.3s1.3,1,2.3,1c0.7,0,1.3-0.2,1.8-0.6 C339.3,600.7,339.7,600.1,339.9,599.2z"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M362.5,603.7v-12.2h2.6v12.2H362.5z"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M397,603.7h-2.8l-1.1-2.8H388l-1.1,2.8h-2.8l5-12.2h2.7L397,603.7z M392.3,598.9l-1.8-4.5l-1.7,4.5H392.3z"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M417.9,603.7v-10.2h-3.8v-2.1h10.2v2.1h-3.8v10.2H417.9z"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M443.8,603.7v-12.2h2.6v12.2H443.8z"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M466.3,597.7c0-1.2,0.2-2.3,0.6-3.1c0.3-0.6,0.7-1.2,1.2-1.7s1.1-0.9,1.7-1.1c0.8-0.3,1.7-0.5,2.8-0.5 c1.9,0,3.4,0.6,4.5,1.7s1.7,2.7,1.7,4.7s-0.6,3.5-1.7,4.6s-2.6,1.7-4.5,1.7s-3.4-0.6-4.6-1.7C466.9,601.1,466.3,599.6,466.3,597.7z  M469,597.6c0,1.4,0.3,2.4,1,3.2c0.7,0.7,1.5,1.1,2.6,1.1c1,0,1.9-0.4,2.5-1.1c0.7-0.7,1-1.8,1-3.2s-0.3-2.4-1-3.1 c-0.6-0.7-1.5-1-2.6-1s-1.9,0.3-2.6,1C469.3,595.1,469,596.2,469,597.6z"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  d: "M498.7,603.7v-12.2h2.5l5.3,8.2v-8.2h2.4v12.2h-2.6l-5.2-8v8H498.7z"
});

var _ref117 = /*#__PURE__*/React.createElement("rect", {
  x: 5.8,
  y: 471.2,
  className: "st4",
  width: 706.1,
  height: 94.9
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M26.9,541.9v-44.5h16.7c3.4,0,6.1,0.5,8.2,1.4c2.1,0.9,3.7,2.3,4.8,4.2c1.2,1.9,1.7,3.8,1.7,5.9 c0,1.9-0.5,3.7-1.5,5.4s-2.6,3-4.7,4.1c2.7,0.8,4.8,2.1,6.2,4s2.2,4.2,2.2,6.7c0,2.1-0.4,4-1.3,5.8c-0.9,1.8-2,3.2-3.3,4.1 c-1.3,1-2.9,1.7-4.9,2.2s-4.4,0.7-7.2,0.7H26.9z M32.8,516h9.6c2.6,0,4.5-0.2,5.6-0.5c1.5-0.4,2.6-1.2,3.4-2.2s1.1-2.3,1.1-3.9 c0-1.5-0.4-2.8-1.1-3.9c-0.7-1.1-1.7-1.9-3-2.3s-3.6-0.6-6.8-0.6h-8.9L32.8,516L32.8,516z M32.8,536.6h11.1c1.9,0,3.2-0.1,4-0.2 c1.4-0.2,2.5-0.6,3.4-1.2c0.9-0.6,1.7-1.4,2.2-2.5c0.6-1.1,0.9-2.3,0.9-3.8c0-1.7-0.4-3.1-1.3-4.3c-0.9-1.2-2-2.1-3.5-2.6 s-3.7-0.7-6.5-0.7H32.8V536.6z"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M80.8,541.9v-44.5h5.9v39.3h21.9v5.3L80.8,541.9L80.8,541.9z"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M123.2,541.9l17.1-44.5h6.4l18.2,44.5h-6.7l-5.2-13.5h-18.6l-4.9,13.5H123.2z M136.1,523.6h15.1l-4.6-12.3 c-1.4-3.7-2.5-6.8-3.2-9.2c-0.6,2.9-1.4,5.7-2.4,8.5L136.1,523.6z"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M213.9,526.2l5.9,1.5c-1.2,4.8-3.5,8.5-6.7,11.1c-3.2,2.5-7.1,3.8-11.8,3.8c-4.8,0-8.7-1-11.7-2.9 c-3-2-5.3-4.8-6.9-8.5c-1.6-3.7-2.4-7.7-2.4-11.9c0-4.6,0.9-8.7,2.7-12.1c1.8-3.5,4.3-6.1,7.6-7.9s6.9-2.7,10.8-2.7 c4.5,0,8.2,1.1,11.2,3.4s5.2,5.5,6.4,9.6l-5.8,1.4c-1-3.2-2.5-5.6-4.5-7.1s-4.4-2.2-7.4-2.2c-3.4,0-6.3,0.8-8.6,2.5 c-2.3,1.6-3.9,3.8-4.8,6.6c-0.9,2.8-1.4,5.6-1.4,8.6c0,3.8,0.6,7.1,1.7,9.9c1.1,2.8,2.8,4.9,5.2,6.3c2.3,1.4,4.9,2.1,7.6,2.1 c3.3,0,6.1-1,8.4-2.9C211.5,532.8,213.1,530,213.9,526.2z"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M239.2,541.9v-44.5h5.9v22.1l22.1-22.1h8l-18.7,18.1L276,542h-7.8l-15.9-22.5l-7.3,7.1V542L239.2,541.9 L239.2,541.9z"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M321.2,527.5l5.6-0.5c0.3,2.2,0.9,4.1,1.8,5.5c1,1.4,2.5,2.6,4.5,3.5s4.3,1.3,6.8,1.3c2.2,0,4.2-0.3,6-1 c1.7-0.7,3-1.6,3.8-2.8s1.3-2.4,1.3-3.8c0-1.4-0.4-2.6-1.2-3.7c-0.8-1-2.1-1.9-4-2.6c-1.2-0.5-3.8-1.2-7.9-2.2s-7-1.9-8.6-2.8 c-2.1-1.1-3.7-2.5-4.8-4.1c-1-1.7-1.6-3.5-1.6-5.5c0-2.2,0.6-4.4,1.9-6.3c1.3-2,3.1-3.4,5.6-4.5c2.5-1,5.2-1.5,8.2-1.5 c3.3,0,6.2,0.5,8.7,1.6s4.5,2.6,5.8,4.7c1.4,2.1,2.1,4.4,2.2,7l-5.7,0.4c-0.3-2.8-1.3-4.9-3.1-6.4c-1.8-1.4-4.3-2.2-7.8-2.2 c-3.6,0-6.2,0.7-7.8,2c-1.6,1.3-2.4,2.9-2.4,4.7c0,1.6,0.6,2.9,1.7,4c1.1,1,4.1,2.1,8.9,3.2c4.8,1.1,8.1,2,9.9,2.8 c2.6,1.2,4.5,2.7,5.7,4.5s1.9,3.9,1.9,6.3c0,2.4-0.7,4.6-2,6.7c-1.4,2.1-3.3,3.7-5.8,4.9s-5.4,1.7-8.6,1.7c-4,0-7.4-0.6-10.1-1.8 s-4.9-2.9-6.4-5.3C322.1,533.2,321.3,530.5,321.2,527.5z"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M388.5,541.9v-39.3h-14.7v-5.3h35.3v5.3h-14.7v39.3H388.5z"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M456.8,497.3h5.9V523c0,4.5-0.5,8-1.5,10.7c-1,2.6-2.8,4.8-5.5,6.4c-2.6,1.7-6.1,2.5-10.4,2.5 c-4.2,0-7.6-0.7-10.2-2.2c-2.7-1.4-4.5-3.5-5.7-6.2c-1.1-2.7-1.7-6.4-1.7-11.2v-25.7h5.9V523c0,3.9,0.4,6.7,1.1,8.6 c0.7,1.8,2,3.2,3.7,4.2c1.8,1,3.9,1.5,6.4,1.5c4.3,0,7.4-1,9.3-2.9c1.8-2,2.8-5.7,2.8-11.3L456.8,497.3L456.8,497.3z"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M485,541.9v-44.5h15.3c3.5,0,6.1,0.2,7.9,0.6c2.6,0.6,4.7,1.7,6.5,3.2c2.3,2,4.1,4.5,5.3,7.6s1.7,6.6,1.7,10.6 c0,3.4-0.4,6.4-1.2,9s-1.8,4.8-3,6.5s-2.6,3.1-4.1,4c-1.5,1-3.2,1.7-5.3,2.2c-2.1,0.5-4.5,0.8-7.2,0.8H485z M490.9,536.6h9.5 c2.9,0,5.2-0.3,6.9-0.8c1.7-0.5,3-1.3,4-2.3c1.4-1.4,2.5-3.3,3.3-5.6c0.8-2.4,1.2-5.2,1.2-8.6c0-4.7-0.8-8.2-2.3-10.7 s-3.4-4.2-5.6-5c-1.6-0.6-4.1-0.9-7.6-0.9h-9.4V536.6z"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M542.5,541.9v-44.5h32.2v5.3h-26.3v13.6H573v5.2h-24.6v15.2h27.3v5.3L542.5,541.9L542.5,541.9z"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M596.3,541.9v-44.5h6l23.4,35v-35h5.7v44.5h-6l-23.4-35v35H596.3z"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M665.1,541.9v-39.3h-14.7v-5.3h35.3v5.3H671v39.3H665.1z"
});

var _ref130 = /*#__PURE__*/React.createElement("polygon", {
  points: "5.8,566.1 175.5,632.1 103.4,566.1 "
});

var _ref131 = /*#__PURE__*/React.createElement("polygon", {
  points: "711.9,566.1 542.2,632.1 614.3,566.1 "
});

var SvgMainLogo = function SvgMainLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 717.7 717.7",
    style: {
      enableBackground: "new 0 0 717.7 717.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.2593,
    y1: -344.897,
    x2: 341.2593,
    y2: -363.9608,
    gradientTransform: "matrix(0.99 0.11 -0.11 0.99 -20.11 533.6801)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#060606"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#171717"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#5A5A5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FBF9FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#EEE6F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#DAC8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#BD9FE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#996AD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6F2CC6"
    }
  })), _ref15, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.2591,
    y1: -361.8951,
    x2: 317.3563,
    y2: -389.4261,
    gradientTransform: "matrix(0.99 0.11 -0.11 0.99 -20.11 533.6801)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#060606"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#171717"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#5A5A5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FBF9FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#EEE6F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#DAC8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#BD9FE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#996AD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6F2CC6"
    }
  })), _ref16, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.6118,
    y1: -380.7984,
    x2: 303.9006,
    y2: -399.338,
    gradientTransform: "matrix(0.99 0.11 -0.11 0.99 -20.11 533.6801)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#060606"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#171717"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#5A5A5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FBF9FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#EEE6F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#DAC8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#BD9FE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#996AD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6F2CC6"
    }
  })), _ref17, _ref18, _ref19, _ref20, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.075,
    y1: -360.6654,
    x2: 385.6705,
    y2: -380.7282,
    gradientTransform: "matrix(0.99 0.11 -0.11 0.99 -20.11 533.6801)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#060606"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#171717"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#5A5A5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FBF9FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#EEE6F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#DAC8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#BD9FE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#996AD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6F2CC6"
    }
  })), _ref21, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 340.6113,
    y1: -342.0473,
    x2: 340.6113,
    y2: -328.6176,
    gradientTransform: "matrix(0.99 0.11 -0.11 0.99 -20.11 533.6801)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#060606"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#171717"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#5A5A5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FBF9FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#EEE6F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#DAC8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#BD9FE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#996AD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6F2CC6"
    }
  })), _ref22, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 361.3277,
    y1: -330.6391,
    x2: 389.3665,
    y2: -358.6779,
    gradientTransform: "matrix(0.99 0.11 -0.11 0.99 -20.11 533.6801)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#060606"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#171717"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#5A5A5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FBF9FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#EEE6F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#DAC8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#BD9FE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#996AD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6F2CC6"
    }
  })), _ref23, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.0477,
    y1: -361.7463,
    x2: 380.0213,
    y2: -399.8154,
    gradientTransform: "matrix(0.99 0.11 -0.11 0.99 -20.11 533.6801)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#060606"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#171717"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#5A5A5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FBF9FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#EEE6F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#DAC8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#BD9FE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#996AD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6F2CC6"
    }
  })), _ref24, _ref25, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.9365,
    y1: -363.5841,
    x2: 348.9365,
    y2: -411.9478,
    gradientTransform: "matrix(0.99 0.11 -0.11 0.99 -20.11 533.6801)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#060606"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#171717"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#5A5A5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FBF9FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#EEE6F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#DAC8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#BD9FE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#996AD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6F2CC6"
    }
  })), _ref26, _ref27, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 329.7434,
    y1: -393.1211,
    x2: 323.9129,
    y2: -403.2261,
    gradientTransform: "matrix(0.99 0.11 -0.11 0.99 -20.11 533.6801)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#060606"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#171717"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#5A5A5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FBF9FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#EEE6F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#DAC8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#BD9FE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#996AD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6F2CC6"
    }
  })), _ref28, _ref29, _ref30, _ref31, _ref32, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 330.348,
    y1: -347.6152,
    x2: 292.6791,
    y2: -347.6152,
    gradientTransform: "matrix(0.99 0.11 -0.11 0.99 -20.11 533.6801)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#060606"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#171717"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#5A5A5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FBF9FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#EEE6F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#DAC8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#BD9FE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#996AD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6F2CC6"
    }
  })), _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.1,
    y1: -158.6237,
    x2: 387.1,
    y2: -118.798,
    gradientTransform: "matrix(1 0 0 1 0 540)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#030106"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#0D0517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#1D0B33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#32145A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#4F1F8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6F2CC6"
    }
  })), _ref100, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 528.5074,
    y1: -297.2,
    x2: 528.5074,
    y2: -351.057,
    gradientTransform: "matrix(1 0 0 1 0 540)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#030106"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#0D0517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#1D0B33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#32145A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#4F1F8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6F2CC6"
    }
  })), _ref101, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 478,
    y1: -145.9,
    x2: 478,
    y2: -213.1627,
    gradientTransform: "matrix(1 0 0 1 0 540)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#111111"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#141217"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#1D1428"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#2B1944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#401E6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#59269C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6F2CC6"
    }
  })), _ref102, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 485.7,
    y1: -144.7,
    x2: 485.7,
    y2: -198.1054,
    gradientTransform: "matrix(1 0 0 1 0 540)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#111111"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#141217"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#1D1428"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#2B1944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#401E6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#59269C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6F2CC6"
    }
  })), _ref103, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 523.306,
    y1: -258.3667,
    x2: 523.306,
    y2: -306.1528,
    gradientTransform: "matrix(0.998 6.348726e-02 -6.348726e-02 0.998 -54.4452 624.8866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#111111"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#141217"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#1D1428"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#2B1944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#401E6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#59269C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6F2CC6"
    }
  })), _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMainLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/main-logo.584a5ade.svg";
export { ForwardRef as ReactComponent };